import {
    BuyerBrief,
    BuyerBriefIntake,
    BuyerBriefJob,
    BriefStatus,
    BriefJobStatus,
    SupplierTypeGroup,
    EvaluationGoal,
    Verdict,
} from "../../../types/BuyerBriefTypes";

export const SALESFORCE_BRIEF_HTML = `<div>
  <style>
    :root {
      --card-bg: #fafafa;
      --card-border: #d9d9d9;
      --success-bg: #e6fadc;
      --success-text: #2fb801;
      --green-leader: #e6fadc;
      --green-leader-text: #2fb801;
      --verdict-background-color: #fafafa;
      --verdict-border-color: #d9d9d9;
      --verdict-title-color: #404040;
    }

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .container {
      font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      color: #404040;
      background: #ffffff;
      font-size: 14px;
    }

    .container.success {
      --verdict-background-color: #f2fced;
      --verdict-border-color: #77e043;
      --verdict-title-color: #2fb801;
    }

    .top-bar {
      border-radius: 8px;
      overflow: hidden;
      border-bottom: 1px solid #d9d9d9;
      background: #fafafa;
      color: #232f3e;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
    }

    .supplier-logo {
      width: 120px;
      height: 96px;
      object-fit: contain;
      padding: 12px;
    }

    .descriptions {
      flex: 1;
      padding: 16px;
    }
    .descriptions table {
      border: none;
      margin: 0;
    }
    .descriptions table th {
      background: none;
      color: #999999;
      padding: 0 0 8px 0;
      text-align: left;
    }
    .descriptions table td {
      color: #666666;
      padding: 0;
      border: none;
    }

    .tag {
      display: inline-block;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 600;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
    }

    .kpi-hero {
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 150px;
      border-radius: 8px;
      background: #1a283d;
      color: white;
      margin: 16px 0;
    }
    .kpi { text-align: center; }
    .kpi-value { font-size: 32px; font-weight: 700; color: var(--verdict-title-color); }
    .kpi-label { font-size: 14px; margin-top: 4px; opacity: 0.9; text-transform: uppercase; letter-spacing: 0.6px; }
    .kpi-note { font-size: 12px; opacity: 0.75; margin-top: 6px; }

    .exec-summary, .recommendation {
      display: flex;
      padding: 16px;
      flex-direction: column;
      gap: 8px;
      border-radius: 8px;
      border-bottom: 1px solid var(--verdict-border-color);
      background: var(--verdict-background-color);
      margin-bottom: 32px;
    }
    .exec-summary h2, .recommendation h2 {
      font-size: 15px;
      font-weight: 700;
      color: var(--verdict-title-color);
      text-transform: uppercase;
    }

    .main { display: flex; gap: 28px; }
    .sidebar {
      width: 180px;
      padding: 12px 16px;
      background: #fafafa;
      border-radius: 8px;
      border-bottom: 1px solid #d9d9d9;
    }
    .sidebar ul { list-style: none; }
    .sidebar li { font-size: 12px; font-weight: 600; margin-bottom: 14px; }
    .sidebar a { color: inherit; text-decoration: none; }

    .content { flex: 1; }
    .section-header {
      padding: 6px 12px;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
      font-size: 14px;
      font-weight: 600;
      border-radius: 4px;
      margin-bottom: 16px;
    }

    .company-card {
      padding: 12px 16px;
      background: #fafafa;
      border-radius: 8px;
      border-bottom: 1px solid #d9d9d9;
      margin-bottom: 16px;
    }
    .company-card h3 { font-size: 14px; margin-bottom: 8px; }

    table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
    th { background: #e5f3ff; padding: 11px 14px; text-align: left; font-size: 12px; text-transform: uppercase; }
    td { padding: 11px 14px; border-bottom: 1px solid #eee; }

    .bar-chart { display: flex; flex-direction: column; gap: 14px; margin: 16px 0; }
    .bar-row { display: flex; align-items: center; gap: 14px; }
    .bar-label { width: 120px; font-size: 12px; text-align: right; }
    .bar-track { flex: 1; height: 24px; background: #e5e7eb; border-radius: 4px; overflow: hidden; }
    .bar-fill { height: 100%; display: flex; align-items: center; justify-content: flex-end; padding-right: 8px; color: white; font-weight: 600; font-size: 11px; }

    .risk-card { padding: 16px; border-radius: 8px; border-bottom: 1px solid; margin-bottom: 12px; }
    .risk-card.medium { background: #fff4eb; border-bottom-color: #ffca99; }
    .risk-card.low { background: #f2fced; border-bottom-color: #77e043; }
    .risk-title { font-weight: 700; text-transform: uppercase; font-size: 12px; margin-bottom: 4px; }

    .score-section { display: flex; gap: 16px; margin-bottom: 20px; }
    .score-ring { text-align: center; background: #fafafa; border-radius: 8px; padding: 14px; flex: 1; }
    .score-ring svg { width: 80px; height: 80px; }
    .score-label { font-size: 11px; font-weight: 600; margin-top: 6px; }

    .confidence { display: inline-block; font-size: 10px; padding: 2px 8px; border-radius: 10px; font-weight: 700; }
    .confidence.high { background: #dcfce7; color: #166534; }

    .footer { text-align: center; padding: 24px; font-size: 12px; color: #666; border-top: 1px solid #eee; margin-top: 40px; }
  </style>

  <div class="container success">
    <div class="top-bar">
      <img class="supplier-logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Salesforce.com_logo.svg/500px-Salesforce.com_logo.svg.png" alt="Salesforce Logo" />
      <div class="descriptions">
        <table>
          <tr>
            <th>Supplier</th>
            <th>Type</th>
            <th>Goal</th>
            <th>Recommendation</th>
            <th>Prepared</th>
          </tr>
          <tr>
            <td><strong>Salesforce, Inc.</strong></td>
            <td>Software / SaaS</td>
            <td>New Supplier Evaluation</td>
            <td><span class="tag verdict-tag">Yes</span></td>
            <td>Apr. 01, 2026</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="kpi-hero">
      <div class="kpi">
        <div class="kpi-value">$37.9B</div>
        <div class="kpi-label">FY2025 Revenue</div>
        <div class="kpi-note">+9% YoY Growth</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">150,000+</div>
        <div class="kpi-label">Active Customers</div>
        <div class="kpi-note">90% of Fortune 500</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">$1.8B</div>
        <div class="kpi-label">Agentforce & Data ARR</div>
        <div class="kpi-note">Q4 FY26 Milestone</div>
      </div>
    </div>

    <div class="exec-summary">
      <h2>Executive Summary</h2>
      <p>
        Salesforce remains the global benchmark for Customer Relationship Management (CRM) and cloud-based enterprise software. Under CEO Marc Benioff, the company has pivoted from a "Cloud-first" to an "AI-first" enterprise with the launch of <strong>Agentforce</strong>—an autonomous AI agent platform. Salesforce maintains a dominant 21.7% CRM market share, significantly outpacing Microsoft and Oracle. While growth has moderated to high single digits, profitability (33% Non-GAAP Operating Margin) and cash flow generation ($13.1B) remain exceptionally strong.
      </p>
    </div>

    <div class="main">
      <div class="sidebar">
        <ul>
          <li><a href="#profile">Company Profile</a></li>
          <li><a href="#financials">Financials</a></li>
          <li><a href="#tech">Product & AI</a></li>
          <li><a href="#risk">Risk Assessment</a></li>
          <li><a href="#esg">ESG & Ethics</a></li>
        </ul>
      </div>

      <div class="content">
        <h2 class="section-header" id="profile">1. Company Profile</h2>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
          <div class="company-card">
            <h3>Market Presence</h3>
            <ul style="list-style: none; font-size: 13px; line-height: 1.6;">
              <li><strong>Headquarters:</strong> San Francisco, CA</li>
              <li><strong>CRM Share:</strong> 21.7% (Global Leader)</li>
              <li><strong>Employee Base:</strong> 76,453 (FY2025)</li>
              <li><strong>Major Clients:</strong> Amazon, Spotify, Walmart, T-Mobile</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>Service Ecosystem</h3>
            <ul style="list-style: none; font-size: 13px; line-height: 1.6;">
              <li><strong>Core Clouds:</strong> Sales, Service, Marketing, Commerce</li>
              <li><strong>Data & Integration:</strong> MuleSoft, Tableau, Data Cloud</li>
              <li><strong>Collaboration:</strong> Slack (Acquired for $27.7B)</li>
              <li><strong>AI Engine:</strong> Agentforce & Einstein</li>
            </ul>
          </div>
        </div>

        <h2 class="section-header" id="financials">2. Financial Health (FY2025-2026)</h2>
        <div class="bar-chart">
          <div class="bar-row">
            <div class="bar-label">FY2024 (Actual)</div>
            <div class="bar-track"><div class="bar-fill" style="width: 84%; background: #93c5fd;">$34.8B</div></div>
          </div>
          <div class="bar-row">
            <div class="bar-label">FY2025 (Actual)</div>
            <div class="bar-track"><div class="bar-fill" style="width: 91%; background: #3b82f6;">$37.9B</div></div>
          </div>
          <div class="bar-row">
            <div class="bar-label">FY2026 (Proj)</div>
            <div class="bar-track"><div class="bar-fill" style="width: 100%; background: #032d60;">$41.4B</div></div>
          </div>
        </div>
        <p style="font-size: 12px; color: #666; margin-bottom: 24px;">Note: Salesforce has achieved 21 consecutive years of profitability and maintains $9.7B in cash/marketable securities as of Jan 2026.</p>

        <h2 class="section-header" id="tech">3. Product & Technical Maturity</h2>
        <table>
          <thead>
            <tr>
              <th>Solution</th>
              <th>Status</th>
              <th>Role in 2026 Strategy</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Agentforce</strong></td>
              <td><span class="confidence high">HIGH GROWTH</span></td>
              <td>Autonomous AI agents replacing traditional copilots.</td>
            </tr>
            <tr>
              <td><strong>Data Cloud</strong></td>
              <td><span class="confidence high">MISSION CRITICAL</span></td>
              <td>Unifying disparate data to fuel AI accuracy.</td>
            </tr>
            <tr>
              <td><strong>Sales & Service Cloud</strong></td>
              <td><span class="confidence high">CORE MATURE</span></td>
              <td>Industry standard for pipeline and case management.</td>
            </tr>
            <tr>
              <td><strong>MuleSoft / Tableau</strong></td>
              <td><span class="confidence high">INTEGRATED</span></td>
              <td>Key for cross-enterprise data visibility and insights.</td>
            </tr>
          </tbody>
        </table>

        <h2 class="section-header" id="risk">4. Risk Assessment</h2>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
          <div class="risk-card medium">
            <div class="risk-title" style="color: #ff8400;">Growth Deceleration</div>
            <div style="font-size: 13px;">Enterprise software spending has normalized. YoY growth slowed from 20%+ to ~9-10% as the market matures.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title" style="color: #ff8400;">Pricing Complexity</div>
            <div style="font-size: 13px;">New consumption-based models for AI (Agentforce) may complicate budgeting compared to seat-based SaaS.</div>
          </div>
        </div>

        <h2 class="section-header" id="esg">5. ESG & Sustainability</h2>
        <div class="score-section">
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#2fb801" stroke-width="8" stroke-dasharray="251 251" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="55" text-anchor="middle" font-size="20" font-weight="700" fill="#404040">100%</text>
            </svg>
            <div class="score-label">Renewable Energy</div>
          </div>
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#3b82f6" stroke-width="8" stroke-dasharray="210 251" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="55" text-anchor="middle" font-size="20" font-weight="700" fill="#404040">A</text>
            </svg>
            <div class="score-label">CDP Climate Score</div>
          </div>
        </div>

        <div class="recommendation">
          <h2>Negotiation Recommendation</h2>
          <p><strong>Verdict: YES</strong> — Salesforce is essential for large enterprises requiring a unified customer view. 
          <strong>Strategy:</strong> Leverage the current market growth slowdown to negotiate multi-year license "lock-ins" and secure bundle pricing for Data Cloud and Agentforce. Request transparency on "Agentic AI" pricing units before scaling pilots.</p>
        </div>
      </div>
    </div>

    <div class="footer">
      Buyer Brief — Salesforce, Inc. | Prepared for Infinity Loop AI | Apr 01, 2026
    </div>
  </div>
</div>
`;

export const SNOWFLAKE_BRIEF_HTML = `<div>
  <style>
    :root {
      --card-bg: #fafafa;
      --card-border: #d9d9d9;
      --success-bg: #e6fadc;
      --success-text: #2fb801;
      --green-leader: #e6fadc;
      --green-leader-text: #2fb801;
      --verdict-background-color: #fafafa;
      --verdict-border-color: #d9d9d9;
      --verdict-title-color: #404040;
    }

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .container {
      font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto,
        sans-serif;
      color: #404040;
      background: #ffffff;
      font-size: 14px;
    }

    .container.warning {
      --verdict-background-color: #fff4eb;
      --verdict-border-color: #ffca99;
      --verdict-title-color: #ff8400;
    }

    .container.danger {
      --verdict-background-color: #fff0f2;
      --verdict-border-color: #fea8b7;
      --verdict-title-color: #fd3559;
    }

    .container.success {
      --verdict-background-color: #f2fced;
      --verdict-border-color: #77e043;
      --verdict-title-color: #2fb801;
    }

    /* TOP HEADER */
    .top-bar {
      border-radius: 8px;
      overflow: hidden;
      border-bottom: 1px solid #d9d9d9;
      background: #fafafa;
      color: #232f3e;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
    }

    .supplier-logo {
      width: 96px;
      height: 96px;
      object-fit: contain;
      padding: 12px;
    }

    .descriptions {
      flex: 1;
      padding: 16px;
    }
    .descriptions table {
      border: none;
      margin: 0;
    }
    .descriptions table th {
      background: none;
      color: #999999;
      padding: 0 0 8px 0;
    }
    .descriptions table td {
      color: #666666;
      padding: 0;
      border: none;
    }
    .descriptions table td strong {
      color: #000000;
    }

    .tag {
      display: inline-block;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 600;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
    }
    .verdict-tag {
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
    }
    .tag-green {
      background: var(--success-bg);
      color: var(--success-text);
    }

    ul li:not(:last-child) {
      margin-bottom: 14px;
    }

    /* KPI HERO */
    .kpi-hero {
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 180px;
      border-radius: 8px;
      background: #1a283d;
      color: white;
      margin: 16px 0;
    }
    .kpi {
      text-align: center;
    }
    .kpi-value {
      font-size: 32px;
      font-weight: 700;
      color: var(--verdict-title-color);
    }
    .kpi-label {
      font-size: 14px;
      margin-top: 4px;
      opacity: 0.9;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }
    .kpi-note {
      font-size: 12px;
      opacity: 0.75;
      margin-top: 6px;
    }

    /* EXEC SUMMARY & RECOMMENDATION */
    .exec-summary,
    .recommendation {
      display: flex;
      padding: 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 8px;
      border-radius: 8px;
      border-bottom: 1px solid var(--verdict-border-color);
      background: var(--verdict-background-color);
      margin-bottom: 32px;
      font-size: 13.2px;
    }
    .exec-summary h2,
    .recommendation h2 {
      font-size: 15px;
      font-weight: 700;
      color: var(--verdict-title-color);
      text-transform: uppercase;
      letter-spacing: 0.8px;
    }
    .recommendation {
      margin: 0;
    }

    /* MAIN LAYOUT */
    .main {
      display: flex;
      gap: 28px;
    }
    .sidebar {
      display: flex;
      width: 180px;
      padding: 12px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 14px;
      border-radius: 8px;
      border-bottom: 1px solid var(--card-border);
      background: var(--card-bg);
    }
    .sidebar ul {
      list-style: none;
    }
    .sidebar li {
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
    }
    .sidebar li:hover,
    .sidebar li.active {
      color: var(--verdict-title-color);
    }
    .sidebar a {
      color: inherit;
      text-decoration: none;
    }

    .content {
      flex: 1;
    }

    .section-header {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      border-radius: 4px;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .section-header:not(:first-child) {
      margin-top: 16px;
    }

    /* Company Profile Cards */
    .company-card {
      display: flex;
      padding: 12px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      flex: 1 0 0;
      align-self: stretch;
      border-radius: 8px;
      border-bottom: 1px solid var(--card-border);
      background: var(--card-bg);
    }
    .company-card h3 {
      font-size: 14px;
      font-weight: 700;
      color: #232f3e;
    }

    /* Tables */
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      margin-bottom: 24px;
      border-radius: 4px;
      overflow: hidden;
    }
    th {
      background: #e5f3ff;
      color: #1a283d;
      padding: 11px 14px;
      text-align: left;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 600;
    }
    td {
      padding: 11px 14px;
      border-bottom: 1px solid #eee;
    }
    tr:nth-child(even) {
      background: #fafafa;
    }

    .leader {
      background: var(--green-leader);
      color: var(--green-leader-text);
      font-size: 11px;
      font-weight: 700;
      padding: 3px 11px;
      border-radius: 20px;
      display: inline-block;
      margin-left: 8px;
    }

    /* Bar Charts */
    .bar-chart {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .bar-row {
      display: flex;
      align-items: center;
      gap: 14px;
    }
    .bar-label {
      width: 120px;
      font-size: 12.8px;
      text-align: right;
      color: #374151;
    }
    .bar-track {
      flex: 1;
      height: 28px;
      background: #e5e7eb;
      border-radius: 6px;
      overflow: hidden;
    }
    .bar-fill {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      color: white;
      font-weight: 600;
      font-size: 12px;
    }

    /* Stacked Bar */
    .stacked-bar {
      display: flex;
      height: 34px;
      border-radius: 8px;
      overflow: hidden;
      margin: 12px 0;
    }
    .stacked-segment {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      color: white;
    }

    /* Risk Cards */
    .risk-card {
      display: flex;
      padding: 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 8px;
      border-radius: 8px;
      border-bottom: 1px solid;
      margin-bottom: 12px;
      font-size: 14px;
    }
    .risk-card .risk-title {
      font-weight: 700;
      font-size: 14px;
      text-transform: uppercase;
    }
    .risk-card.low {
      background: #f2fced;
      border-bottom-color: #77e043;
    }
    .risk-card.low .risk-title {
      color: #2fb801;
    }
    .risk-card.medium {
      background: #fff4eb;
      border-bottom-color: #ffca99;
    }
    .risk-card.medium .risk-title {
      color: #ff8400;
    }
    .risk-card.high {
      background: #fff0f2;
      border-bottom-color: #fea8b7;
    }
    .risk-card.high .risk-title {
      color: #fd3559;
    }

    .small-note {
      font-size: 12px;
      color: #6b7280;
      font-style: italic;
      margin-block: 16px;
    }

    .footer {
      text-align: center;
      padding: 24px 32px;
      font-size: 12px;
      color: #666;
      border-top: 1px solid #eee;
      margin-top: 40px;
    }

    .two-col {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

    /* Score Rings */
    .score-section {
      display: flex;
      gap: 16px;
      margin-bottom: 20px;
      flex-wrap: wrap;
    }
    .score-ring {
      text-align: center;
      background: var(--card-bg);
      border-bottom: 1px solid var(--card-border);
      border-radius: 8px;
      padding: 14px 20px;
      flex: 1;
      min-width: 120px;
    }
    .score-ring svg {
      width: 120px;
      height: 120px;
    }
    .score-ring .score-label {
      font-size: 11px;
      color: #6b7280;
      margin-top: 6px;
      font-weight: 600;
    }
    .score-ring .score-source {
      font-size: 10px;
      color: #6b7280;
    }

    /* Confidence badge */
    .confidence {
      display: inline-block;
      font-size: 10px;
      padding: 2px 8px;
      border-radius: 10px;
      font-weight: 600;
      text-transform: uppercase;
    }
    .confidence.high {
      background: #dcfce7;
      color: #166534;
    }
    .confidence.medium {
      background: #fef3c7;
      color: #92400e;
    }
    .confidence.low {
      background: #fee2e2;
      color: #991b1b;
    }
  </style>

  <div class="container warning">
    <div class="top-bar">
      <img
        class="supplier-logo"
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Snowflake_Logo.svg/500px-Snowflake_Logo.svg.png"
        alt="Snowflake Logo"
      />
      <div class="descriptions">
        <table>
          <tbody>
            <tr class="descriptions-row">
              <th class="descriptions-item" colspan="2">Supplier</th>
              <th class="descriptions-item" colspan="2">Type</th>
              <th class="descriptions-item" colspan="2">Goal</th>
              <th class="descriptions-item" colspan="1">Recommendation</th>
              <th class="descriptions-item" colspan="1">Prepared</th>
            </tr>
            <tr class="descriptions-row">
              <td class="descriptions-item" colspan="2"><strong>Snowflake Inc.</strong></td>
              <td class="descriptions-item" colspan="2">Software / SaaS</td>
              <td class="descriptions-item" colspan="2">Renewal Decision</td>
              <td class="descriptions-item" colspan="1">
                <span class="tag verdict-tag">Renegotiate</span>
              </td>
              <td class="descriptions-item" colspan="1">
                <span style="white-space: nowrap">Apr. 01, 2026</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="kpi-hero">
      <div class="kpi">
        <div class="kpi-value">$4.3B</div>
        <div class="kpi-label">FY26 Revenue (Est.)</div>
        <div class="kpi-note">~22% YoY Growth</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">10,000+</div>
        <div class="kpi-label">Total Customers</div>
        <div class="kpi-note">Includes ~700 Forbes G2000</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">131%</div>
        <div class="kpi-label">Net Revenue Retention</div>
        <div class="kpi-note">Strong expansion dynamics</div>
      </div>
    </div>

    <div class="exec-summary">
      <h2>Executive Summary</h2>
      <p>
        Snowflake (NYSE: SNOW) remains the dominant independent Data Cloud platform, offering a highly scalable, multi-cloud architecture that separates storage from compute. Under the leadership of Sridhar Ramaswamy, Snowflake has accelerated its AI and ML capabilities through Snowflake Cortex, Document AI, and native LLM integrations, allowing enterprises to run generative AI workloads directly where their data resides. While usage-based pricing requires tight governance, their ecosystem and platform maturity make them a mission-critical vendor.
      </p>
    </div>

    <div class="main">
      <div class="sidebar">
        <ul>
          <li><a href="#company-profile">Company Profile</a></li>
          <li><a href="#financial-health">Financial Health</a></li>
          <li><a href="#product-technical">Product &amp; Technical</a></li>
          <li><a href="#market-position">Market Position</a></li>
          <li><a href="#risk-assessment">Risk Assessment</a></li>
          <li><a href="#esg">ESG &amp; Sustainability</a></li>
        </ul>
      </div>

      <div class="content">
        <h2 class="section-header" id="company-profile">1. Company Profile</h2>
        <div class="two-col">
          <div class="company-card">
            <h3>Company Snapshot</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Founded:</strong> 2012</li>
              <li><strong>HQ:</strong> Bozeman, Montana</li>
              <li><strong>IPO:</strong> September 2020 (NYSE: SNOW)</li>
              <li><strong>Leadership:</strong> Sridhar Ramaswamy (CEO), Mike Scarpelli (CFO)</li>
              <li><strong>Core Differentiator:</strong> Cross-cloud data sharing and zero-copy cloning.</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>Customer Footprint</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Scale:</strong> 10,000+ active customers globally.</li>
              <li><strong>Key Verticals:</strong> Financial Services, Healthcare, Retail, Tech.</li>
              <li><strong>Data Sharing:</strong> Over 30% of customers utilize Snowflake Data Clean Rooms and sharing.</li>
              <li><strong>Ecosystem:</strong> Deep integrations with AWS, Azure, and Google Cloud.</li>
            </ul>
          </div>
        </div>

        <h2 class="section-header" id="financial-health">2. Financial Health & Growth</h2>
        <div style="background: #fafafa; border-radius: 8px; padding: 20px; margin-bottom: 24px">
          <div style="font-weight: 600; margin-bottom: 12px">Product Revenue Growth Trajectory</div>
          <div class="bar-chart">
            <div class="bar-row">
              <div class="bar-label">FY2024 (Actual)</div>
              <div class="bar-track"><div class="bar-fill" style="width: 65%; background: #93c5fd">$2.67B</div></div>
            </div>
            <div class="bar-row">
              <div class="bar-label">FY2025 (Actual)</div>
              <div class="bar-track"><div class="bar-fill" style="width: 82%; background: #3b82f6">$3.40B</div></div>
            </div>
            <div class="bar-row">
              <div class="bar-label">FY2026 (Est.)</div>
              <div class="bar-track"><div class="bar-fill" style="width: 100%; background: #1e3a8a">$4.30B+</div></div>
            </div>
          </div>
          <p class="small-note">
            Note: Snowflake recognizes revenue based on consumption, not strictly SaaS subscriptions. They maintain exceptional cash flow generation and over $4B+ in cash and short-term investments, ensuring strong financial viability.
          </p>
        </div>

        <h2 class="section-header" id="product-technical">3. Product &amp; Technical Deep-Dive</h2>
        <table>
          <tbody>
            <tr>
              <th>Core Component</th>
              <th>Description</th>
              <th>Status / Maturity</th>
            </tr>
            <tr>
              <td><strong>Snowflake Data Cloud</strong></td>
              <td>Foundational data warehouse and data lake workload engine.</td>
              <td><span class="confidence high">CORE PRODUCT</span></td>
            </tr>
            <tr>
              <td><strong>Snowpark</strong></td>
              <td>Developer framework to deploy Python, Java, and Scala natively.</td>
              <td><span class="confidence high">HIGH ADOPTION</span></td>
            </tr>
            <tr>
              <td><strong>Snowflake Cortex & Arctic</strong></td>
              <td>Fully managed AI services and open-source enterprise LLMs.</td>
              <td><span class="confidence medium">RAPID GROWTH</span></td>
            </tr>
            <tr>
              <td><strong>Streamlit in Snowflake</strong></td>
              <td>Framework to turn data scripts into shareable web apps.</td>
              <td><span class="confidence high">MATURE</span></td>
            </tr>
          </tbody>
        </table>

        <h2 class="section-header" id="market-position">4. Market Position</h2>
        <div class="company-card">
          <p>
            Snowflake is definitively recognized as a <strong>Leader</strong> in cloud database and analytics markets <span class="leader">Gartner Magic Quadrant Leader</span>. Unlike native tools (AWS Redshift, GCP BigQuery), Snowflake offers absolute portability and identical UX across all three major clouds. Their primary rivalry is with <strong>Databricks</strong>, as both companies aggressively converge on the "Data Lakehouse" and enterprise AI markets. 
          </p>
        </div>

        <h2 class="section-header" id="risk-assessment">5. Risk Assessment</h2>
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 32px">
          <div class="risk-card medium">
            <div class="risk-title">Cost Governance</div>
            <div>The consumption-based model can lead to "bill shock." Requires dedicated FinOps practices and strict resource monitors.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title">Databricks Rivalry</div>
            <div>Intense competition for AI/ML workloads. Databricks retains a stronghold in unstructured data and heavy data engineering.</div>
          </div>
          <div class="risk-card low">
            <div class="risk-title">Vendor Lock-In</div>
            <div>While multi-cloud capable, extracting raw data out of Snowflake proprietary formats (Micro-partitions) incurs egress costs.</div>
          </div>
        </div>

        <h2 class="section-header" id="esg">6. ESG &amp; Sustainability</h2>
        <div class="score-section">
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#22c55e"
                stroke-width="8"
                stroke-dasharray="210 251.3"
                stroke-dashoffset="-62.8"
                stroke-linecap="round"
                transform="rotate(-90 50 50)"
              ></circle>
              <text x="50" y="50" text-anchor="middle" font-size="18" font-weight="700" fill="#374151">100%</text>
            </svg>
            <div class="score-label">Renewable Electricity</div>
            <div class="score-source">Global Offices (Scope 2)</div>
          </div>
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle
                cx="50"
                cy="50"
                r="40"
                fill="none"
                stroke="#3b82f6"
                stroke-width="8"
                stroke-dasharray="190 251.3"
                stroke-dashoffset="-61.3"
                stroke-linecap="round"
                transform="rotate(-90 50 50)"
              ></circle>
              <text x="50" y="50" text-anchor="middle" font-size="22" font-weight="700" fill="#374151">B</text>
            </svg>
            <div class="score-label">CDP Rating</div>
            <div class="score-source">Climate Change</div>
          </div>
        </div>

        <div class="recommendation">
          <h2>Recommendation</h2>
          <p>
            Snowflake provides the most robust, scalable, and cross-cloud-friendly data platform in the market. The aggressive rollout of Cortex and native App frameworks cements their value not just as a warehouse, but as an application backend.
          </p>
          <p class="verdict" style="margin-top: 12px; font-weight: 600">
            Verdict: 	RENEGOTIATE — We recommend executing a multi-year capacity commit to secure maximum discounting on Snowflake credits. Simultaneously, establish a strict FinOps Center of Excellence to govern compute cluster sizes and auto-suspend policies.
          </p>
        </div>
      </div>
    </div>

    <div class="footer">
      Buyer Brief — Snowflake Inc. | Prepared by Infinity Loop AI | April 01, 2026
    </div>
  </div>
</div>`;

const SNOWFLAKE_INTAKE: BuyerBriefIntake = {
    supplierName: "Snowflake",
    supplierWebsite: "https://www.snowflake.com",
    supplierType: SupplierTypeGroup.PROFESSIONAL_SERVICES,
    evaluationGoal: EvaluationGoal.RENEWAL_DECISION,
    selectedTopics: [
        "company_overview",
        "financial_health",
        "market_position",
        "risk_assessment",
        "customer_reputation",
        "domain_expertise",
        "key_personnel",
        "billing_rates",
        "conflict_check",
    ],
    selectedAddons: [],
};

export const AWS_BRIEF_HTML = `<style>
      :root {
        --card-bg: #fafafa;
        --card-border: #d9d9d9;
        --success-bg: #e6fadc;
        --success-text: #2FB801;
        --green-leader: #e6fadc;
        --green-leader-text: #2FB801;
        --verdict-background-color: #fafafa
        --verdict-border-color: #d9d9d9
        --verdict-title-color: #404040
      }

      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .container {
        font-family:
          Inter,
          system-ui,
          -apple-system,
          BlinkMacSystemFont,
          "Segoe UI",
          Roboto,
          sans-serif;
        color: #404040;
        background:#ffffff;
        font-size: 14px;
      }

      .container.danger {
        --verdict-background-color: #fff0f2;
        --verdict-border-color: #fea8b7;
        --verdict-title-color: #fd3559;
      }

      .container.warning {
        --verdict-background-color: #fff4eb;
        --verdict-border-color: #ffca99;
        --verdict-title-color: #ff8400;
      }

      .container.success {
        --verdict-background-color: #F2FCED;
        --verdict-border-color: #77E043;
        --verdict-title-color: #2FB801;
      }

      /* TOP HEADER */
      .top-bar {
        border-radius: 8px;
        overflow: hidden;
        border-bottom: 1px solid #d9d9d9;
        background: #fafafa;
        color: #232f3e;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
      }

      .supplier-logo {
        width: 96px;
        height: 96px;
        object-fit: contain;
      }

      .descriptions {
        flex: 1;
        padding: 16px;
      }
      .descriptions table {
        border:none;
        margin: 0;
      }
      .descriptions table th {
        background: none;
        color: #999999;
        padding: 0 0 8px 0;
      }
      .descriptions table td {
        color: #666666;
        padding: 0;
        border: none;
      }
      .descriptions table td strong{
        color: #000000;
      }

      .tag {
        display: inline-block;
        border-radius: 4px;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 600;
        background: var(--verdict-background-color);
        color: var(--verdict-title-color);
      }
      .verdict-tag {
        background: var(--verdict-background-color);
        color: var(--verdict-title-color);
      }
      .tag-green {
        background: var(--success-bg);
        color: var(--success-text);
      }

      ul li:not(:last-child) {
        margin-bottom: 14px;
      }
      

      /* KPI HERO */
      .kpi-hero {
        display: flex;
        padding: 16px;
        justify-content: center;
        align-items: center;
        gap: 180px;
        border-radius: 8px;
        background: #1a283d;
        color: white;
        margin: 16px 0;
      }
      .kpi {
        text-align: center;
      }
      .kpi-value {
        font-size: 32px;
        font-weight: 700;
        color: var(--verdict-title-color);
      }
      .kpi-label {
        font-size: 14px;
        margin-top: 4px;
        opacity: 0.9;
        text-transform: uppercase;
        letter-spacing: 0.6px;
      }
      .kpi-note {
        font-size: 12px;
        opacity: 0.75;
        margin-top: 6px;
      }

      /* EXEC SUMMARY & RECOMMENDATION - Exact spec */
      .exec-summary,
      .recommendation {
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        border-radius: 8px;
        border-bottom: 1px solid var(--verdict-border-color);
        background: var(--verdict-background-color);
        margin-bottom: 32px;
        font-size: 13.2px;
      }
      .exec-summary h2,
      .recommendation h2 {
        font-size: 15px;
        font-weight: 700;
        color: var(--verdict-title-color);
        text-transform: uppercase;
        letter-spacing: 0.8px;
      }

      .recommendation {
        margin: 0;
      }

      /* MAIN LAYOUT */
      .main {
        display: flex;
        gap: 28px;
      }
      .sidebar {
        display: flex;
        width: 180px;
        padding: 12px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
        border-radius: 8px;
        border-bottom: 1px solid var(--card-border) ;
        background: var(--card-bg);
      }
      .sidebar ul {
        list-style: none;
      }
      .sidebar li {
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
      }
      .sidebar li:hover,
      .sidebar li.active {
        color: var(--verdict-title-color);
      }

      .sidebar a {
        color: inherit;
      }

      .content {
        flex: 1;
      }

      .section-header {
        display: flex;
        padding: 6px 12px;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        border-radius: 4px;
        background: var(--verdict-background-color);
        color: var(--verdict-title-color);
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .section-header:not(:first-child) {
        margin-top: 16px;
      }

      /* Company Profile Cards */
      .company-card {
        display: flex;
        padding: 12px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
        align-self: stretch;
        border-radius: 8px;
        border-bottom: 1px solid var(--card-border);
        background: var(--card-bg);
      }
      .company-card h3 {
        font-size: 14px;
        font-weight: 700;
        color: #232f3e;
      }

      /* Tables - Header updated */
      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        margin-bottom: 24px;
        border-radius: 4px;
        overflow:hidden;
      }
      th {
        background: #e5f3ff;
        color: #1a283d;
        padding: 11px 14px;
        text-align: left;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        font-weight: 600;
      }
      td {
        padding: 11px 14px;
        border-bottom: 1px solid #eee;
      }
      tr:nth-child(even) {
        background: #fafafa;
      }

      .leader {
        background: var(--green-leader);
        color: var(--green-leader-text);
        font-size: 11px;
        font-weight: 700;
        padding: 3px 11px;
        border-radius: 20px;
        display: inline-block;
        margin-left: 8px;
      }

      /* Bar Charts */
      .bar-chart {
        display: flex;
        flex-direction: column;
        gap: 14px;
      }
      .bar-row {
        display: flex;
        align-items: center;
        gap: 14px;
      }
      .bar-label {
        width: 120px;
        font-size: 12.8px;
        text-align: right;
        color: #374151;
      }
      .bar-track {
        flex: 1;
        height: 28px;
        background: #e5e7eb;
        border-radius: 6px;
        overflow: hidden;
      }
      .bar-fill {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        color: white;
        font-weight: 600;
        font-size: 12px;
      }

      /* Stacked Bar */
      .stacked-bar {
        display: flex;
        height: 34px;
        border-radius: 8px;
        overflow: hidden;
        margin: 12px 0;
      }
      .stacked-segment {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 700;
        color: white;
      }

      /* Risk Cards - Like Exec Summary but risk-colored */
      .risk-card {
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        border-radius: 8px;
        border-bottom: 1px solid;
        margin-bottom: 12px;
        font-size: 14px;
      }
      .risk-card .risk-title {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
      }
      .risk-card.low {
        background: #f2fced;
        border-bottom-color: #77e043;
      }
      .risk-card.low .risk-title {
        color: #2fb801;
      }
      .risk-card.medium {
        background: #fff4eb;
        border-bottom-color: #ffca99;
      }
      .risk-card.medium .risk-title {
        color: #ff8400;
      }
      .risk-card.high {
        background: #fff0f2;
        border-bottom-color: #fea8b7;
      }
      .risk-card.high .risk-title {
        color: #fd3559;
      }

      .small-note {
        font-size: 12px;
        color: #6b7280;
        font-style: italic;
        margin-block: 16px;
      }

      .footer {
        text-align: center;
        padding: 24px 32px;
        font-size: 12px;
        color: #666;
        border-top: 1px solid #eee;
        margin-top: 40px;
      }

      .two-col {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
    </style>
<div class="container warning">
      <!-- TOP HEADER -->
      <div class="top-bar">
        <img class="supplier-logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/960px-Amazon_Web_Services_Logo.svg.png" alt="AWS Logo">
        <div class="descriptions">
            <table>
                <tbody>
                    <tr class="descriptions-row">
                        <th class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-label">Supplier</span>
                            </div>
                        </th>
                        <th class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-label">Type</span>
                            </div>
                        </th>
                        <th class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-label">Goal</span>
                            </div>
                        </th>
                        <th class="descriptions-item" colspan="1">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-label">Recommendation</span>
                            </div>
                        </th>
                        <th class="descriptions-item" colspan="1">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-label">Created</span>
                            </div>
                        </th>
                    </tr>
                    <tr class="descriptions-row">
                        <td class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-content"
                                    ><strong>Amazon Web Services</strong></span
                                >
                            </div>
                        </td>
                        <td class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-content">Cloud & Infrastructure</span>
                            </div>
                        </td>
                        <td class="descriptions-item" colspan="2">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-content">Competitive Comparison</span>
                            </div>
                        </td>
                        <td class="descriptions-item" colspan="1">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-content"
                                    ><span class="tag verdict-tag">Conditional</span></span
                                >
                            </div>
                        </td>
                        <td class="descriptions-item" colspan="1">
                            <div class="descriptions-item-container">
                                <span class="descriptions-item-content"
                                    ><span style="white-space: nowrap">Mar. 19, 2026</span></span
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>

      <!-- KPI HERO -->
      <div class="kpi-hero">
        <div class="kpi">
          <div class="kpi-value">$128.7B</div>
          <div class="kpi-label">2025 Revenue</div>
          <div class="kpi-note">+20% YoY | 35% op. margin</div>
        </div>
        <div class="kpi">
          <div class="kpi-value">~31%</div>
          <div class="kpi-label">Global Market Share</div>
          <div class="kpi-note">Q4 2025 | #1 worldwide</div>
        </div>
        <div class="kpi">
          <div class="kpi-value">240+</div>
          <div class="kpi-label">Services Offered</div>
          <div class="kpi-note">Broadest portfolio in market</div>
        </div>
        <div class="kpi">
          <div class="kpi-value">$244B</div>
          <div class="kpi-label">Order Backlog</div>
          <div class="kpi-note">+40% YoY | Multi-year visibility</div>
        </div>
      </div>

      <!-- EXECUTIVE SUMMARY -->
      <div class="exec-summary">
        <h2>Executive Summary</h2>
        <p>
          AWS is the world's largest cloud infrastructure provider with ~31% global market share, $128.7B in 2025 revenue
          (+20% YoY), and a $142B annualized run rate. Led by CEO Matt Garman (since June 2024), AWS is investing
          aggressively in AI ($200B capex planned) with custom silicon (Trainium, Graviton) and Bedrock as its AI platform.
          While AWS leads in service breadth (240+ services), analyst coverage (Gartner Leader 15 years running), and
          compliance certifications (143 standards), it faces intensifying competition: Azure is growing at nearly 2x AWS's
          rate (39% vs. 20%), fueled by OpenAI integration, and Google Cloud is surging on AI/ML. Key buyer concerns include
          pricing complexity, aggressive egress fees that function as lock-in, and significant regulatory headwinds (FTC
          antitrust case, UK CMA investigation, $2.5B Prime settlement). For a competitive comparison, AWS remains the safe
          default with the deepest feature set, but buyers should evaluate Azure and GCP for AI-heavy workloads where the gap
          has narrowed considerably.
        </p>
      </div>

      <div class="main">
        <!-- SIDEBAR -->
        <div class="sidebar">
          <ul>
            <li><a href="#company-profile-leadership">Company Profile &amp; Leadership</a></li>
            <li><a href="#financial-health">Financial Health</a></li>
            <li><a href="#competitive-analysis">Head-to-Head Analysis</a></li>
            <li><a href="#pricing-tco">Pricing &amp; TCO Analysis</a></li>
            <li><a href="#security-compliance">Security & Compliance Posture</a></li>
            <li><a href="#reputation">Reputation & Analyst Recognition</a></li>
            <li><a href="#customer-case-studies">Notable Customer Case Studies</a></li>
            <li><a href="#switching-cost">Switching Cost & Migration Analysis</a></li>
            <li><a href="#industry-trends">Industry Trends & Market Shifts</a></li>
            <li><a href="#risk-assessment">Risk Assessment</a></li>
          </ul>
        </div>

        <!-- CONTENT -->
        <div class="content">
          <!-- 1. Company Profile & Leadership -->
          <h2 class="section-header" id="company-profile-leadership">1. Company Profile &amp; Leadership</h2>
          <div class="two-col">
            <div class="company-card">
              <h3>AWS Snapshot</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
                <li><strong>Founded:</strong> 2006 (launched S3 and EC2)</li>
                <li><strong>Parent:</strong> Amazon.com, Inc. (NASDAQ: AMZN)</li>
                <li><strong>HQ:</strong> Seattle, WA</li>
                <li><strong>Global Footprint:</strong> 34 regions, 108 Availability Zones, 750K+ active customers</li>
                <li><strong>Employees:</strong> ~115,000 (est. AWS division)</li>
                <li><strong>% of Amazon Profit:</strong> AWS generates ~63% of Amazon's total operating income</li>
              </ul>
            </div>
            <div class="company-card">
              <h3>Leadership</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
                <li>
                  <strong>CEO:</strong> Matt Garman (since June 2024) — 3rd AWS CEO, at Amazon since 2006, helped launch
                  original AWS services
                </li>
                <li><strong>Previous CEO:</strong> Adam Selipsky (2021–2024)</li>
                <li><strong>Amazon CEO:</strong> Andy Jassy (former AWS CEO 2006–2021)</li>
                <li><strong>VP AI/ML:</strong> Matt Wood</li>
                <li>
                  <strong>Garman's Vision:</strong> "The next 80–90% of enterprise AI value will come from agents." Targeting
                  $300–400B in annual revenue.
                </li>
              </ul>
            </div>
          </div>

          <!-- 2. Financial Health -->
          <h2 class="section-header" id="financial-health">2. Financial Health</h2>
          <div>
            <div style="font-weight: 600; margin-bottom: 12px">AWS Quarterly Revenue Trajectory (2024–2025)</div>
            <div class="bar-chart">
              <div class="bar-row">
                <div class="bar-label">Q1 2025</div>
                <div class="bar-track"><div class="bar-fill" style="width: 77%; background: #f9a8d4">$29.3B</div></div>
              </div>
              <div class="bar-row">
                <div class="bar-label">Q2 2025</div>
                <div class="bar-track"><div class="bar-fill" style="width: 82%; background: #fb7185">$31.4B</div></div>
              </div>
              <div class="bar-row">
                <div class="bar-label">Q3 2025</div>
                <div class="bar-track"><div class="bar-fill" style="width: 90%; background: #fb923c">$33.5B</div></div>
              </div>
              <div class="bar-row">
                <div class="bar-label">Q4 2025</div>
                <div class="bar-track">
                  <div class="bar-fill" style="width: 100%; background: #10b981">$35.6B (+24%)</div>
                </div>
              </div>
            </div>
            <p class="small-note">
              Source: Amazon Q4 2025 earnings (Feb 5, 2026). Q4 was the fastest quarterly growth in 13 quarters.
            </p>
          </div>

          <table>
            <tbody><tr>
              <th>Metric</th>
              <th>FY2025</th>
              <th>FY2024</th>
              <th>Signal</th>
            </tr>
            <tr>
              <td>Annual Revenue</td>
              <td>$128.7B</td>
              <td>$107.6B</td>
              <td style="color: #22c55e">+20% YoY</td>
            </tr>
            <tr>
              <td>Operating Income</td>
              <td>$45.6B</td>
              <td>$35.5B</td>
              <td style="color: #22c55e">35% margin</td>
            </tr>
            <tr>
              <td>Q4 Revenue</td>
              <td>$35.6B</td>
              <td>$28.8B</td>
              <td style="color: #22c55e">+24% (accelerating)</td>
            </tr>
            <tr>
              <td>Annualized Run Rate</td>
              <td>$142B</td>
              <td>—</td>
              <td style="color: #22c55e">Massive scale</td>
            </tr>
            <tr>
              <td>Backlog</td>
              <td>$244B (+40%)</td>
              <td>$174B</td>
              <td style="color: #22c55e">Multi-year demand</td>
            </tr>
            <tr>
              <td>AI Revenue (Bedrock)</td>
              <td>Multi-billion ARR</td>
              <td>—</td>
              <td style="color: #22c55e">+60% QoQ</td>
            </tr>
            <tr>
              <td>Custom Silicon ARR</td>
              <td>$10B+ (Graviton/Trainium)</td>
              <td>—</td>
              <td style="color: #22c55e">Triple-digit growth</td>
            </tr>
            <tr>
              <td>2025 Capex (Amazon total)</td>
              <td>~$100B (planned $200B)</td>
              <td>$78B</td>
              <td style="color: #f59e0b">Aggressive spend</td>
            </tr>
          </tbody></table>

          <!-- 3. Head-to-Head -->
          <h2 class="section-header" id="competitive-analysis">3. Head-to-Head: AWS vs. Azure vs. Google Cloud</h2>

          <div style="background: #fafafa; border-radius: 8px; padding: 20px; margin-bottom: 24px">
            <div style="font-weight: 600; margin-bottom: 10px">Cloud Infrastructure Market Share (Q3 2025)</div>
            <div class="stacked-bar">
              <div class="stacked-segment" style="width: 32%; background: #1a283d">AWS 31%</div>
              <div class="stacked-segment" style="width: 22%; background: #0078d4">Azure 22%</div>
              <div class="stacked-segment" style="width: 11%; background: #4285f4">GCP 11%</div>
              <div class="stacked-segment" style="width: 35%; background: #6b7280">Others 36%</div>
            </div>
            <p class="small-note">
              Source: Synergy Research, Canalys, Statista Q3 2025 estimates. Market = ~$400B for full year 2025.
            </p>
          </div>

          <div style="background: #fafafa; border-radius: 8px; padding: 20px; margin-bottom: 24px">
            <div style="font-weight: 600; margin-bottom: 12px">YoY Revenue Growth Rate (Q4 2025)</div>
            <div class="bar-chart">
              <div class="bar-row">
                <div class="bar-label">Azure</div>
                <div class="bar-track">
                  <div class="bar-fill" style="width: 81%; background: #0078d4">
                    39%
                  </div>
                </div>
              </div>
              <div class="bar-row">
                <div class="bar-label">Google Cloud</div>
                <div class="bar-track"><div class="bar-fill" style="width: 60%; background: #4285f4">~30%</div></div>
              </div>
              <div class="bar-row">
                <div class="bar-label">AWS</div>
                <div class="bar-track"><div class="bar-fill" style="width: 50%; background: #1a283d">24%</div></div>
              </div>
            </div>
          </div>

          <!-- Comparison Table -->
          <table>
            <tbody><tr>
              <th>Category</th>
              <th>AWS</th>
              <th>Azure</th>
              <th>Google Cloud</th>
            </tr>
            <tr>
              <td><strong>Service Breadth</strong></td>
              <td>240+ services <span class="leader leader-green">LEADER</span></td>
              <td>200+ services</td>
              <td>150+ services</td>
            </tr>
            <tr>
              <td><strong>AI / GenAI Platform</strong></td>
              <td>Bedrock (Claude, Llama, etc.), SageMaker, Trainium</td>
              <td>Azure OpenAI (GPT-4, o1), Copilot stack <span class="tag tag-green">LEADER</span></td>
              <td>Vertex AI, Gemini, TPUs</td>
            </tr>
            <tr>
              <td><strong>Enterprise Integration</strong></td>
              <td>Strong; broad partner ecosystem</td>
              <td>
                Microsoft 365, Entra ID, Teams, Dynamics <span class="tag tag-green">LEADER</span>
              </td>
              <td>Workspace, BigQuery; weaker enterprise</td>
            </tr>
            <tr>
              <td><strong>Hybrid / On-Prem</strong></td>
              <td>Outposts, EKS Anywhere</td>
              <td>Azure Arc, Azure Stack <span class="tag tag-green">LEADER</span></td>
              <td>Anthos (declining focus)</td>
            </tr>
            <tr>
              <td><strong>Data &amp; Analytics</strong></td>
              <td>Redshift, Athena, EMR, Glue</td>
              <td>Synapse, Fabric, Power BI</td>
              <td>BigQuery, Looker, Dataflow <span class="tag tag-green" >LEADER</span></td>
            </tr>
            <tr>
              <td><strong>Kubernetes / Containers</strong></td>
              <td>EKS, ECS, Fargate</td>
              <td>AKS</td>
              <td>GKE (created K8s) <span class="tag tag-green">LEADER</span></td>
            </tr>
            <tr>
              <td><strong>Compliance Certs</strong></td>
              <td>143 standards <span class="leader leader-green">LEADER</span></td>
              <td>100+ certifications</td>
              <td>100+ certifications</td>
            </tr>
            <tr>
              <td><strong>Global Regions</strong></td>
              <td>34 regions, 108 AZs <span class="leader leader-green">LEADER</span></td>
              <td>60+ regions</td>
              <td>40+ regions</td>
            </tr>
            <tr>
              <td><strong>Pricing Transparency</strong></td>
              <td>Complex; FinOps needed</td>
              <td>Complex; tied to EA/licensing</td>
              <td>Simpler; sustained-use discounts <span class="tag tag-green">LEADER</span></td>
            </tr>
            <tr>
              <td><strong>Open Source Alignment</strong></td>
              <td>Mixed (SSPL controversy)</td>
              <td>Moderate (GitHub, VS Code)</td>
              <td>Strongest (K8s, TensorFlow, Go) <span class="tag tag-green">LEADER</span></td>
            </tr>
          </tbody></table>

          <!-- 4. Pricing & TCO -->
          <h2 class="section-header" id="pricing-tco">4. Pricing &amp; TCO Analysis</h2>
          <div class="two-col">
            <div class="company-card">
              <h3>Pricing Model</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>On-Demand:</strong> Pay-per-hour/second, no commitment, highest unit cost.</li>
                <li><strong>Savings Plans:</strong> 1- or 3-year commitment for 30–72% discount on compute.</li>
                <li><strong>Reserved Instances:</strong> 1/3-year, capacity reservation, up to 75% off.</li>
                <li><strong>Spot Instances:</strong> Up to 90% off for interruptible workloads.</li>
                <li><strong>Enterprise Discount Program (EDP):</strong> Custom volume discounts for $1M+ annual spend.</li>
                <li><strong>Free Tier:</strong> 12-month free tier + always-free services (Lambda, DynamoDB, etc.).</li>
              </ul>
            </div>
            <div class="company-card">
              <h3>Hidden Cost Traps</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>Data egress:</strong> $0.09/GB to internet (first 10TB); can = 15% of total bill.</li>
                <li><strong>Cross-AZ traffic:</strong> $0.02/GB round-trip; invisible budget drain.</li>
                <li><strong>NAT Gateway:</strong> $0.045/GB processing fee on top of egress — 10TB = $450 extra.</li>
                <li><strong>Non-linear tier jumps:</strong> M10 → M30 = 6–8x cost increase, not 3x.</li>
                <li><strong>Auto-scaling surprises:</strong> Compute scales automatically; bills spike without alerts.</li>
                <li><strong>AI pipeline costs:</strong> GPU + data movement in AI workloads add 20–50% hidden costs.</li>
                <li><strong>Support plans:</strong> Enterprise Support = 7–10% of monthly spend.</li>
              </ul>
            </div>
          </div>
          <p class="small-note">
            Cost reality: Organizations routinely underestimate AWS costs by 40–60% vs. initial budgets (Getmonetizely,
            2025). FinOps practices and tooling are essential for any deployment &gt;$50K/year.
          </p>

          <!-- 5. Security & Compliance -->
          <h2 class="section-header" id="security-compliance">5. Security &amp; Compliance Posture</h2>
          <table>
            <tbody><tr>
              <th>Framework</th>
              <th>Status</th>
              <th>Notes</th>
            </tr>
            <tr>
              <td>SOC 1 / SOC 2 / SOC 3</td>
              <td style="color: #22c55e">Certified</td>
              <td>Independent auditor-validated; reports via AWS Artifact</td>
            </tr>
            <tr>
              <td>ISO 27001, 27017, 27018, 27701</td>
              <td style="color: #22c55e">Certified</td>
              <td>Full information security management suite</td>
            </tr>
            <tr>
              <td>PCI DSS Level 1</td>
              <td style="color: #22c55e">Certified</td>
              <td>Highest level of PCI compliance</td>
            </tr>
            <tr>
              <td>FedRAMP (Moderate &amp; High)</td>
              <td style="color: #22c55e">Authorized</td>
              <td>GovCloud for High; US East/West for Moderate</td>
            </tr>
            <tr>
              <td>HIPAA</td>
              <td style="color: #22c55e">BAA Available</td>
              <td>No CSP "certification" exists; BAA + HIPAA-eligible services</td>
            </tr>
            <tr>
              <td>GDPR</td>
              <td style="color: #22c55e">Compliant</td>
              <td>Data Processing Addendum; EU data residency options</td>
            </tr>
            <tr>
              <td>C5 (Germany), IRAP (Australia), MTCS (Singapore)</td>
              <td style="color: #22c55e">Certified</td>
              <td>Regional certifications for local compliance</td>
            </tr>
            <tr>
              <td>Total Standards Supported</td>
              <td colspan="2">
                <strong>143 security standards and compliance certifications</strong> — broadest in the industry
              </td>
            </tr>
          </tbody></table>
          <p class="small-note">
            Shared Responsibility Model: AWS secures the infrastructure; customers secure their data, access, and
            configurations. AWS Audit Manager automates evidence collection for compliance audits.
          </p>

          <!-- 6. Reputation -->
          <h2 class="section-header" id="reputation">6. Reputation &amp; Analyst Recognition</h2>
          <div class="two-col">
            <div class="company-card">
              <h3>Gartner (2025)</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li>
                  <strong>Leader:</strong> Strategic Cloud Platform Services — 15th consecutive year. Highest on "Ability to
                  Execute."
                </li>
                <li><strong>Leader:</strong> Cloud-Native Application Platforms &amp; Container Management (2 yrs).</li>
                <li><strong>Leader:</strong> AI Code Assistants (2nd year).</li>
              </ul>
            </div>
            <div class="company-card">
              <h3>Forrester (2025)</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>Leader:</strong> Serverless Development Platforms — #1 in Current Offering &amp; Strategy.</li>
                <li><strong>Leader:</strong> Contact-Center-as-a-Service (Amazon Connect).</li>
                <li><strong>Strongest:</strong> Public Cloud Platforms (Q4 2024 Wave).</li>
              </ul>
            </div>
          </div>

          <!-- 7. Notable Customer Case Studies -->
          <h2 class="section-header" id="customer-case-studies">7. Notable Customer Case Studies</h2>
          <table>
            <tbody><tr>
              <th>Customer</th>
              <th>Industry</th>
              <th>Use Case</th>
              <th>Outcome</th>
            </tr>
            <tr>
              <td>Netflix</td>
              <td>Media/Streaming</td>
              <td>Entire streaming infrastructure on AWS</td>
              <td>Global scale; rule-based self-managing infra via Lambda</td>
            </tr>
            <tr>
              <td>FINRA</td>
              <td>Financial Regulation</td>
              <td>Market surveillance</td>
              <td>Analyzes 75B market events/day to detect fraud</td>
            </tr>
            <tr>
              <td>Experian</td>
              <td>Data/Financial</td>
              <td>.NET modernization via AWS Transform</td>
              <td>40% reduction in developer effort; 300 engineering days saved</td>
            </tr>
            <tr>
              <td>Novo Nordisk</td>
              <td>Pharma</td>
              <td>Clinical study report generation</td>
              <td>Report time: 12 weeks → 10 minutes (GenAI)</td>
            </tr>
            <tr>
              <td>Trellix</td>
              <td>Cybersecurity</td>
              <td>AI agent security tools (Claude on Bedrock)</td>
              <td>23x cost savings; 95% accuracy; 1000s of hours saved</td>
            </tr>
          </tbody></table>

          <!-- 8. Switching Cost & Migration Analysis -->
          <h2 class="section-header" id="switching-cost">8. Switching Cost &amp; Migration Analysis</h2>
          <div class="two-col">
            <div class="company-card">
              <h3>Lock-in Mechanisms</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li>
                  <strong>Proprietary services:</strong> Lambda, DynamoDB, Aurora, Step Functions — no portable equivalents.
                </li>
                <li><strong>Egress fees:</strong> $0.09/GB to move data out — petabyte migration = 6-figure cost.</li>
                <li><strong>Savings Plans / RIs:</strong> 1–3 year financial commitments discourage switching.</li>
              </ul>
            </div>
            <div class="company-card">
              <h3>Migration Cost Estimates</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>Replatform (lift-and-shift):</strong> $50K–$200K depending on app count and data volume.</li>
                <li>
                  <strong>Re-architect (cloud-native):</strong> $200K–$1M+; measured in engineer-months to engineer-years.
                </li>
                <li><strong>Data egress for 100TB:</strong> ~$9,000 in AWS egress fees alone.</li>
                <li><strong>Timeline:</strong> 3–18 months for meaningful migration depending on complexity.</li>
              </ul>
            </div>
          </div>

          <!-- 9. Industry Trends -->
          <h2 class="section-header" id="industry-trends">9. Industry Trends &amp; Market Shifts</h2>
          <div class="two-col">
            <div class="company-card">
              <h3>Cloud Market (2025–2026)</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>Market size:</strong> $400B+ in 2025; expected &gt;$800B by 2026. CAGR ~21%.</li>
                <li>
                  <strong>AI is the growth engine:</strong> Big Three spent $240B combined in 2025 on AI/data center capex.
                </li>
                <li><strong>Multi-cloud adoption:</strong> 87% of enterprises now use multi-cloud (Flexera 2025).</li>
              </ul>
            </div>
            <div class="company-card">
              <h3>Competitive Dynamics</h3>
              <ul style="list-style: none; padding: 0; font-size: 14px">
                <li><strong>Azure closing the gap:</strong> 39% growth vs. AWS's 24% — OpenAI partnership is key driver.</li>
                <li>
                  <strong>GCP's AI resurgence:</strong> Gemini + TPUs + BigQuery positioning GCP as analytics/AI leader.
                </li>
                <li>
                  <strong>AWS share declining slowly:</strong> From ~33% (2021) to ~31% (2025) as competitors grow faster.
                </li>
              </ul>
            </div>
          </div>

          <!-- 10. Risk Assessment -->
          <h2 class="section-header" id="risk-assessment">10. Risk Assessment</h2>
          <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 32px">
            <div class="risk-card medium">
              <div class="risk-title">FTC Antitrust Case</div>
              <div>
                Ongoing FTC monopoly lawsuit (Amazon marketplace). Class action certified for 288M consumers. Could impact
                Amazon's business practices broadly.
              </div>
            </div>
            <div class="risk-card medium">
              <div class="risk-title">UK CMA Investigation</div>
              <div>
                CMA concluded cloud market investigation (Jul 2025). May designate AWS as having "strategic market status,"
                enabling legally binding conduct requirements.
              </div>
            </div>
            <div class="risk-card high">
              <div class="risk-title">Pricing Complexity</div>
              <div>
                Customers routinely underestimate costs by 40–60%. Egress fees, cross-AZ charges, and auto-scaling create
                unpredictable bills without FinOps discipline.
              </div>
            </div>
            <div class="risk-card medium">
              <div class="risk-title">Prime Settlement ($2.5B)</div>
              <div>
                Amazon settled FTC dark-patterns case for $2.5B (Oct 2025). Signals regulatory willingness to impose major
                penalties.
              </div>
            </div>
            <div class="risk-card medium">
              <div class="risk-title">Vendor Lock-in</div>
              <div>
                Deepest proprietary surface of the Big Three. Migration requires engineer-months/years and significant
                rewriting.
              </div>
            </div>
            <div class="risk-card low">
              <div class="risk-title">Financial Stability</div>
              <div>
                Backed by Amazon ($638B FY2025 revenue). Zero going-concern risk. $244B backlog provides multi-year revenue
                visibility.
              </div>
            </div>
            <div class="risk-card medium">
              <div class="risk-title">Growth Deceleration</div>
              <div>
                AWS growing at 20–24% vs. Azure at 39% and GCP at 30%+. Market share slowly eroding. AI competitive gap with
                Azure/OpenAI.
              </div>
            </div>
            <div class="risk-card low">
              <div class="risk-title">Security &amp; Compliance</div>
              <div>
                143 certifications. Gartner Leader 15 years. Best-in-class compliance tooling (Artifact, Audit Manager). Low
                security risk.
              </div>
            </div>
            <div class="risk-card low">
              <div class="risk-title">Product Viability</div>
              <div>240+ services; $10B+ custom silicon ARR; Bedrock multi-billion ARR. No risk of product stagnation.</div>
            </div>
          </div>

          <!-- RECOMMENDATION -->
          <div class="recommendation">
            <h2>Recommendation</h2>
            <p>
              AWS remains the broadest and most mature cloud platform, with unmatched service depth, compliance coverage, and
              global infrastructure. It is the safest choice for general-purpose cloud workloads, regulated industries, and
              organizations that value ecosystem breadth. However, buyers should seriously evaluate Azure for
              Microsoft-centric enterprises and AI workloads (OpenAI integration), and Google Cloud for data analytics,
              Kubernetes, and cost transparency. AWS's pricing complexity is a genuine operational burden — budget for FinOps
              tooling and expertise from day one.
            </p>
            <p class="verdict" style="margin-top: 12px; font-weight: 600">
              Verdict: CONDITIONAL — Best for breadth, compliance, and ecosystem maturity. But don't default to AWS
              without benchmarking Azure (for AI/enterprise) and GCP (for analytics/cost simplicity). Negotiate EDPs
              aggressively, demand egress fee caps, and adopt open standards (Terraform, K8s, PostgreSQL) to preserve
              optionality.
            </p>
          </div>

          <div class="footer">Buyer Brief — Amazon Web Services (AWS) | Prepared March 17, 2026 | Confidential</div>
        </div>
      </div>
    </div>`;

const AWS_INTAKE: BuyerBriefIntake = {
    supplierName: "Amazon Web Services (AWS)",
    supplierWebsite: "https://aws.amazon.com",
    supplierType: SupplierTypeGroup.CLOUD_INFRASTRUCTURE,
    evaluationGoal: EvaluationGoal.NEW_SUPPLIER_EVALUATION,
    selectedTopics: [
        "company_overview",
        "financial_health",
        "market_position",
        "product_capabilities",
        "security_compliance",
        "pricing_model",
    ],
    selectedAddons: [],
};

export const MONGODB_BRIEF_HTML = `<div>
  <style>
    :root {
      --card-bg: #fafafa;
      --card-border: #d9d9d9;
      --success-bg: #e6fadc;
      --success-text: #2fb801;
      --green-leader: #e6fadc;
      --green-leader-text: #2fb801;
      --verdict-background-color: #fafafa;
      --verdict-border-color: #d9d9d9;
      --verdict-title-color: #404040;
    }

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .container {
      font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto,
        sans-serif;
      color: #404040;
      background: #ffffff;
      font-size: 14px;
    }

    .container.warning {
      --verdict-background-color: #fff4eb;
      --verdict-border-color: #ffca99;
      --verdict-title-color: #ff8400;
    }

    .container.danger {
      --verdict-background-color: #fff0f2;
      --verdict-border-color: #fea8b7;
      --verdict-title-color: #fd3559;
    }

    .container.success {
      --verdict-background-color: #F2FCED;
      --verdict-border-color: #77e043;
      --verdict-title-color: #2FB801;
    }

    /* TOP HEADER */
    .top-bar {
      border-radius: 8px;
      overflow: hidden;
      border-bottom: 1px solid #d9d9d9;
      background: #fafafa;
      color: #232f3e;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
    }

    .supplier-logo {
      width: 96px;
      height: 96px;
      object-fit: contain;
      padding: 12px;
    }

    .descriptions {
      flex: 1;
      padding: 16px;
    }
    .descriptions table {
      border: none;
      margin: 0;
    }
    .descriptions table th {
      background: none;
      color: #999999;
      padding: 0 0 8px 0;
    }
    .descriptions table td {
      color: #666666;
      padding: 0;
      border: none;
    }
    .descriptions table td strong {
      color: #000000;
    }

    .tag {
      display: inline-block;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 600;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
    }
    .verdict-tag {
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
    }
    .tag-green {
      background: var(--success-bg);
      color: var(--success-text);
    }

    ul li:not(:last-child) {
      margin-bottom: 14px;
    }

    /* KPI HERO */
    .kpi-hero {
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 180px;
      border-radius: 8px;
      background: #1a283d;
      color: white;
      margin: 16px 0;
    }
    .kpi {
      text-align: center;
    }
    .kpi-value {
      font-size: 32px;
      font-weight: 700;
      color: var(--verdict-title-color);
    }
    .kpi-label {
      font-size: 14px;
      margin-top: 4px;
      opacity: 0.9;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }
    .kpi-note {
      font-size: 12px;
      opacity: 0.75;
      margin-top: 6px;
    }

    /* EXEC SUMMARY & RECOMMENDATION */
    .exec-summary,
    .recommendation {
      display: flex;
      padding: 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 8px;
      border-radius: 8px;
      border-bottom: 1px solid var(--verdict-border-color);
      background: var(--verdict-background-color);
      margin-bottom: 32px;
      font-size: 13.2px;
    }
    .exec-summary h2,
    .recommendation h2 {
      font-size: 15px;
      font-weight: 700;
      color: var(--verdict-title-color);
      text-transform: uppercase;
      letter-spacing: 0.8px;
    }
    .recommendation {
      margin: 0;
    }

    /* MAIN LAYOUT */
    .main {
      display: flex;
      gap: 28px;
    }
    .sidebar {
      display: flex;
      width: 180px;
      padding: 12px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 14px;
      border-radius: 8px;
      border-bottom: 1px solid var(--card-border);
      background: var(--card-bg);
    }
    .sidebar ul {
      list-style: none;
    }
    .sidebar li {
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
    }
    .sidebar li:hover,
    .sidebar li.active {
      color: var(--verdict-title-color);
    }
    .sidebar a {
      color: inherit;
      text-decoration: none;
    }

    .content {
      flex: 1;
    }

    .section-header {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      border-radius: 4px;
      background: var(--verdict-background-color);
      color: var(--verdict-title-color);
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .section-header:not(:first-child) {
      margin-top: 16px;
    }

    /* Company Profile Cards */
    .company-card {
      display: flex;
      padding: 12px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      flex: 1 0 0;
      align-self: stretch;
      border-radius: 8px;
      border-bottom: 1px solid var(--card-border);
      background: var(--card-bg);
    }
    .company-card h3 {
      font-size: 14px;
      font-weight: 700;
      color: #232f3e;
    }

    /* Tables */
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      margin-bottom: 24px;
      border-radius: 4px;
      overflow: hidden;
    }
    th {
      background: #e5f3ff;
      color: #1a283d;
      padding: 11px 14px;
      text-align: left;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 600;
    }
    td {
      padding: 11px 14px;
      border-bottom: 1px solid #eee;
    }
    tr:nth-child(even) {
      background: #fafafa;
    }

    .leader {
      background: var(--green-leader);
      color: var(--green-leader-text);
      font-size: 11px;
      font-weight: 700;
      padding: 3px 11px;
      border-radius: 20px;
      display: inline-block;
      margin-left: 8px;
    }

    /* Bar Charts */
    .bar-chart {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .bar-row {
      display: flex;
      align-items: center;
      gap: 14px;
    }
    .bar-label {
      width: 120px;
      font-size: 12.8px;
      text-align: right;
      color: #374151;
    }
    .bar-track {
      flex: 1;
      height: 28px;
      background: #e5e7eb;
      border-radius: 6px;
      overflow: hidden;
    }
    .bar-fill {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      color: white;
      font-weight: 600;
      font-size: 12px;
    }

    /* Stacked Bar */
    .stacked-bar {
      display: flex;
      height: 34px;
      border-radius: 8px;
      overflow: hidden;
      margin: 12px 0;
    }
    .stacked-segment {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      color: white;
    }

    /* Risk Cards */
    .risk-card {
      display: flex;
      padding: 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 8px;
      border-radius: 8px;
      border-bottom: 1px solid;
      margin-bottom: 12px;
      font-size: 14px;
    }
    .risk-card .risk-title {
      font-weight: 700;
      font-size: 14px;
      text-transform: uppercase;
    }
    .risk-card.low {
      background: #f2fced;
      border-bottom-color: #77e043;
    }
    .risk-card.low .risk-title {
      color: #2fb801;
    }
    .risk-card.medium {
      background: #fff4eb;
      border-bottom-color: #ffca99;
    }
    .risk-card.medium .risk-title {
      color: #ff8400;
    }
    .risk-card.high {
      background: #fff0f2;
      border-bottom-color: #fea8b7;
    }
    .risk-card.high .risk-title {
      color: #fd3559;
    }

    .small-note {
      font-size: 12px;
      color: #6b7280;
      font-style: italic;
      margin-block: 16px;
    }

    .footer {
      text-align: center;
      padding: 24px 32px;
      font-size: 12px;
      color: #666;
      border-top: 1px solid #eee;
      margin-top: 40px;
    }

    .two-col {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

    /* Score Rings */
    .score-section {
      display: flex;
      gap: 16px;
      margin-bottom: 20px;
      flex-wrap: wrap;
    }
    .score-ring {
      text-align: center;
      background: var(--card-bg);
      border-bottom: 1px solid var(--card-border);
      border-radius: 8px;
      padding: 14px 20px;
      flex: 1;
      min-width: 120px;
    }
    .score-ring svg {
      width: 120px;
      height: 120px;
    }
    .score-ring .score-label {
      font-size: 11px;
      color: #6b7280;
      margin-top: 6px;
      font-weight: 600;
    }
    .score-ring .score-source {
      font-size: 10px;
      color: #6b7280;
    }

    /* Traffic light badges */
    .traffic-light {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 3px 10px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: 600;
    }
    .traffic-light.green { background: #dcfce7; color: #166534; }
    .traffic-light.amber { background: #fef3c7; color: #92400e; }
    .traffic-light.red { background: #fee2e2; color: #991b1b; }
    .traffic-light::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    .traffic-light.green::before { background: #22c55e; }
    .traffic-light.amber::before { background: #f59e0b; }
    .traffic-light.red::before { background: #ef4444; }

    /* Confidence badge */
    .confidence {
      display: inline-block;
      font-size: 10px;
      padding: 2px 8px;
      border-radius: 10px;
      font-weight: 600;
    }
    .confidence.high { background: #dcfce7; color: #166534; }
    .confidence.medium { background: #fef3c7; color: #92400e; }
    .confidence.low { background: #fee2e2; color: #991b1b; }
  </style>

  <div class="container success">

    <!-- TOP BAR -->
    <div class="top-bar">
      <img
        class="supplier-logo"
        src="https://upload.wikimedia.org/wikipedia/en/thumb/5/5a/MongoDB_Fores-Green.svg/500px-MongoDB_Fores-Green.svg.png"
        alt="MongoDB Logo"
      />
      <div class="descriptions">
        <table>
          <tbody>
            <tr class="descriptions-row">
              <th class="descriptions-item" colspan="2">Supplier</th>
              <th class="descriptions-item" colspan="2">Type</th>
              <th class="descriptions-item" colspan="2">Goal</th>
              <th class="descriptions-item" colspan="1">Recommendation</th>
              <th class="descriptions-item" colspan="1">Prepared</th>
            </tr>
            <tr class="descriptions-row">
              <td class="descriptions-item" colspan="2"><strong>MongoDB, Inc.</strong></td>
              <td class="descriptions-item" colspan="2">SaaS / Database Platform</td>
              <td class="descriptions-item" colspan="2">New Supplier Evaluation</td>
              <td class="descriptions-item" colspan="1">
                <span class="tag verdict-tag">Strong Yes</span>
              </td>
              <td class="descriptions-item" colspan="1">
                <span style="white-space: nowrap">Feb. 26, 2026</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- KPI HERO -->
    <div class="kpi-hero">
      <div class="kpi">
        <div class="kpi-value">$2.4B+</div>
        <div class="kpi-label">FY2026 Revenue (est.)</div>
        <div class="kpi-note">+19% YoY | Q4 reports Mar 2, 2026</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">62,500+</div>
        <div class="kpi-label">Total Customers</div>
        <div class="kpi-note">As of Oct 31, 2025</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">~45%</div>
        <div class="kpi-label">NoSQL Market Share</div>
        <div class="kpi-note">Category leader | 6sense 2025</div>
      </div>
      <div class="kpi">
        <div class="kpi-value">$2.3B</div>
        <div class="kpi-label">Cash Position</div>
        <div class="kpi-note">Strong balance sheet</div>
      </div>
    </div>

    <!-- EXEC SUMMARY -->
    <div class="exec-summary">
      <h2>Executive Summary</h2>
      <p>
        MongoDB is the dominant NoSQL database provider (~45% market share) with $2.4B+ in projected FY2026 revenue and
        62,500+ customers globally. The company is undergoing a CEO transition (CJ Desai replaced Dev Ittycheria in Nov
        2025) and is aggressively pivoting toward AI/vector search capabilities. Atlas, its managed cloud service, now
        represents 75% of revenue and is growing at 30% YoY. Key considerations for a new buyer: strong product-market
        fit for modern applications, robust security certifications, but watch for pricing complexity at scale, vendor
        lock-in risk, and an active securities fraud class action. The NoSQL market itself is projected to grow at ~29%
        CAGR through 2030, and MongoDB is well-positioned as the category leader.
      </p>
    </div>

    <!-- MAIN LAYOUT -->
    <div class="main">
      <div class="sidebar">
        <ul>
          <li><a href="#company-profile">Company Profile</a></li>
          <li><a href="#financial-health">Financial Health</a></li>
          <li><a href="#product-technical">Product &amp; Technical</a></li>
          <li><a href="#security-compliance">Security &amp; Compliance</a></li>
          <li><a href="#pricing-lockin">Pricing &amp; Lock-in</a></li>
          <li><a href="#competitors">Competitor Landscape</a></li>
          <li><a href="#industry-trends">Industry Trends</a></li>
          <li><a href="#case-studies">Customer Case Studies</a></li>
          <li><a href="#risk-assessment">Risk Assessment</a></li>
          <li><a href="#esg">ESG &amp; Sustainability</a></li>
        </ul>
      </div>

      <div class="content">

        <!-- 1. COMPANY PROFILE -->
        <h2 class="section-header" id="company-profile">1. Company Profile</h2>
        <div class="two-col">
          <div class="company-card">
            <h3>Company Snapshot</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Founded:</strong> 2007 (as 10gen) by Dwight Merriman, Eliot Horowitz, Kevin Ryan</li>
              <li><strong>HQ:</strong> 1633 Broadway, New York, NY</li>
              <li><strong>IPO:</strong> 2017 (NASDAQ: MDB)</li>
              <li><strong>Ownership:</strong> Publicly traded</li>
              <li><strong>Market Cap:</strong> ~$25–30B (as of Feb 2026)</li>
              <li><strong>Customers:</strong> 62,500+ across 100+ countries</li>
              <li><strong>Employees:</strong> ~5,500+ across 6 continents</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>Leadership (Post-Transition)</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>CEO:</strong> CJ Desai (since Nov 10, 2025) — ex-Cloudflare President, ex-ServiceNow COO ($1.5B→$10B revenue)</li>
              <li><strong>CTO:</strong> Mark Porter</li>
              <li><strong>CMO:</strong> May Petry (since 2022)</li>
              <li><strong>Board Chair:</strong> Tom Killalea</li>
              <li><strong>Prior CEO:</strong> Dev Ittycheria (2014–2025) — remains on board as advisor</li>
            </ul>
          </div>
        </div>

        <!-- 2. FINANCIAL HEALTH -->
        <h2 class="section-header" id="financial-health">2. Financial Health</h2>
        <div style="background: #fafafa; border-radius: 8px; padding: 20px; margin-bottom: 24px">
          <div style="font-weight: 600; margin-bottom: 12px">Revenue Growth Trajectory (Annual)</div>
          <div class="bar-chart">
            <div class="bar-row">
              <div class="bar-label">FY2023</div>
              <div class="bar-track"><div class="bar-fill" style="width: 53%; background: #6ee7b7">$1.28B</div></div>
            </div>
            <div class="bar-row">
              <div class="bar-label">FY2024</div>
              <div class="bar-track"><div class="bar-fill" style="width: 69%; background: #34d399">$1.68B</div></div>
            </div>
            <div class="bar-row">
              <div class="bar-label">FY2025</div>
              <div class="bar-track"><div class="bar-fill" style="width: 83%; background: #10b981">$2.01B</div></div>
            </div>
            <div class="bar-row">
              <div class="bar-label">FY2026 (est.)</div>
              <div class="bar-track"><div class="bar-fill" style="width: 100%; background: #00684A">$2.43B</div></div>
            </div>
          </div>
          <p class="small-note">Source: MongoDB investor relations, Q3 FY2026 earnings release (Dec 1, 2025). FY2026 est. based on company guidance of $2.434B–$2.439B.</p>
        </div>

        <table>
          <tbody>
            <tr>
              <th>Metric</th>
              <th>Q3 FY2026 (Oct 2025)</th>
              <th>Q4 FY2025 (Jan 2025)</th>
              <th>Signal</th>
            </tr>
            <tr>
              <td>Total Revenue</td>
              <td>$628.3M (+19% YoY)</td>
              <td>$548.4M (+20% YoY)</td>
              <td style="color: #22c55e">Healthy</td>
            </tr>
            <tr>
              <td>Atlas Revenue (% of total)</td>
              <td>75% (+30% YoY)</td>
              <td>71% (+24% YoY)</td>
              <td style="color: #22c55e">Accelerating</td>
            </tr>
            <tr>
              <td>Non-GAAP Gross Margin</td>
              <td>74%</td>
              <td>~75%</td>
              <td style="color: #22c55e">Strong</td>
            </tr>
            <tr>
              <td>Non-GAAP EPS</td>
              <td>$1.32</td>
              <td>$1.28</td>
              <td style="color: #22c55e">Profitable (non-GAAP)</td>
            </tr>
            <tr>
              <td>Free Cash Flow (Q3)</td>
              <td>$140.1M</td>
              <td>—</td>
              <td style="color: #22c55e">Cash Generative</td>
            </tr>
            <tr>
              <td>Cash &amp; Equivalents</td>
              <td>$2.3B</td>
              <td>—</td>
              <td style="color: #22c55e">Strong Runway</td>
            </tr>
            <tr>
              <td>GAAP Net Income</td>
              <td>-$2.0M</td>
              <td>—</td>
              <td style="color: #f59e0b">Near Breakeven</td>
            </tr>
          </tbody>
        </table>

        <!-- 3. PRODUCT & TECHNICAL -->
        <h2 class="section-header" id="product-technical">3. Product &amp; Technical Deep-Dive</h2>
        <div class="two-col">
          <div class="company-card">
            <h3>Core Product Portfolio</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>MongoDB Atlas</strong> — Fully managed multi-cloud DBaaS (AWS, Azure, GCP). 75% of revenue.</li>
              <li><strong>Enterprise Advanced</strong> — Self-managed enterprise offering with advanced security.</li>
              <li><strong>Community Edition</strong> — Free, open-source (SSPL license).</li>
              <li><strong>Atlas Vector Search</strong> — Native vector DB for RAG and semantic search.</li>
              <li><strong>Atlas Search</strong> — Full-text search engine built on Apache Lucene.</li>
              <li><strong>Atlas Charts</strong> — Built-in data visualization.</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>AI / Innovation Roadmap (2025–2026)</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Voyage AI integration</strong> — Acquired embedding models; Voyage 4 outperforms Gemini &amp; Cohere on MTEB leaderboard.</li>
              <li><strong>Automated Embedding</strong> — One-click vector embedding inside MongoDB (Jan 2026).</li>
              <li><strong>GraphRAG</strong> — Graph-based retrieval augmented generation for explainable AI.</li>
              <li><strong>Natural Language Querying</strong> — Agentic apps can query MongoDB in natural language.</li>
              <li><strong>MCP Server</strong> — Model Context Protocol for AI IDE integrations.</li>
              <li><strong>mongot open-sourced</strong> (SSPL) for search/vector search transparency.</li>
            </ul>
          </div>
        </div>

        <!-- 4. SECURITY & COMPLIANCE -->
        <h2 class="section-header" id="security-compliance">4. Security &amp; Compliance</h2>
        <table>
          <tbody>
            <tr>
              <th>Certification / Standard</th>
              <th>Status</th>
              <th>Confidence</th>
            </tr>
            <tr>
              <td>SOC 2 Type II</td>
              <td style="color: #22c55e">Certified</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>ISO 27001:2022</td>
              <td style="color: #22c55e">Certified</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>PCI DSS v4.0</td>
              <td style="color: #22c55e">Certified</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>HIPAA</td>
              <td style="color: #22c55e">Examined (3rd party)</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>GDPR</td>
              <td style="color: #22c55e">Compliant (DPO appointed)</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>FedRAMP Moderate</td>
              <td style="color: #22c55e">Authorized (Atlas for Gov)</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>CSA STAR Level 2</td>
              <td style="color: #22c55e">Certified</td>
              <td><span class="confidence high">HIGH</span></td>
            </tr>
            <tr>
              <td>HITRUST CSF</td>
              <td style="color: #22c55e">SOC 2 + HITRUST mapped</td>
              <td><span class="confidence medium">MEDIUM</span></td>
            </tr>
          </tbody>
        </table>
        <p class="small-note">Encryption: AES-256 at rest (default, cannot be disabled), TLS in transit (default, cannot be disabled), Queryable Encryption for data-in-use. Customer-managed KMS supported. NIST CSF aligned. Source: MongoDB Trust Center.</p>

        <!-- 5. PRICING & LOCK-IN -->
        <h2 class="section-header" id="pricing-lockin">5. Pricing &amp; Lock-in Analysis</h2>
        <table>
          <tbody>
            <tr>
              <th>Tier</th>
              <th>Model</th>
              <th>Best For</th>
              <th>Starting Cost</th>
            </tr>
            <tr>
              <td>Free (M0)</td>
              <td>Forever free</td>
              <td>Learning / prototyping</td>
              <td>$0 (512MB storage)</td>
            </tr>
            <tr>
              <td>Flex</td>
              <td>Pay-as-you-go</td>
              <td>Dev / test environments</td>
              <td>Low (usage-based)</td>
            </tr>
            <tr>
              <td>Dedicated (M10–M20)</td>
              <td>Hourly compute + storage</td>
              <td>Pre-production, small workloads</td>
              <td>~$57/month (M10)</td>
            </tr>
            <tr>
              <td>Dedicated (M30+)</td>
              <td>Hourly compute + storage</td>
              <td>Production workloads</td>
              <td>~$200+/month</td>
            </tr>
            <tr>
              <td>Serverless</td>
              <td>Per-operation pricing</td>
              <td>Variable/unpredictable workloads</td>
              <td>Pay per read/write/storage</td>
            </tr>
            <tr>
              <td>Enterprise Advanced</td>
              <td>Custom / sales-negotiated</td>
              <td>On-prem, private cloud, regulated</td>
              <td>Contact sales</td>
            </tr>
          </tbody>
        </table>

        <div class="two-col">
          <div class="company-card">
            <h3>Lock-in Risk Factors</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Proprietary query language</strong> — MQL is MongoDB-specific; migration requires query rewriting.</li>
              <li><strong>Atlas-specific services</strong> — Atlas Search, Charts, Triggers are not portable.</li>
              <li><strong>Data export</strong> — mongodump/mongoexport available, but large-scale migration is non-trivial.</li>
              <li><strong>SSPL license</strong> — Not OSI-approved open source; limits competitive hosting.</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>Hidden Cost Watch</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Data transfer (egress)</strong> — Cross-region and outbound data transfer fees add up.</li>
              <li><strong>Backup storage</strong> — Continuous backup snapshots billed separately.</li>
              <li><strong>Auto-scaling surprises</strong> — Compute can scale up automatically; costs may spike.</li>
              <li><strong>Support tiers</strong> — Premium support is an add-on; base support is limited.</li>
            </ul>
          </div>
        </div>

        <!-- 6. COMPETITOR LANDSCAPE -->
        <h2 class="section-header" id="competitors">6. Competitor Landscape</h2>

        <div style="background: #fafafa; border-radius: 8px; padding: 20px; margin-bottom: 24px">
          <div class="chart-container">
    <div class="chart-title">NoSQL Market Share (2025–2026)</div>
    <div class="bar-chart">
      <div class="bar-row">
        <div class="bar-label">MongoDB</div>
        <div class="bar-track"><div class="bar-fill" style="width:91%; background: #10b981;">~45.5%</div></div>
      </div>
      <div class="bar-row">
        <div class="bar-label">DynamoDB</div>
        <div class="bar-track"><div class="bar-fill" style="width:22%; background: #fb923c;">~11.1%</div></div>
      </div>
      <div class="bar-row">
        <div class="bar-label">HBase</div>
        <div class="bar-track"><div class="bar-fill" style="width:8%; background: #fb7185;">~4.0%</div></div>
      </div>
      <div class="bar-row">
        <div class="bar-label">Couchbase</div>
        <div class="bar-track"><div class="bar-fill" style="width:4%; background: #f9a8d4;">~2.0%</div></div>
      </div>
      <div class="bar-row">
        <div class="bar-label">Others</div>
        <div class="bar-track"><div class="bar-fill" style="width:75%; background: #67e3ba;">~37.4%</div></div>
      </div>
    </div>
    <p class="small-note">Source: 6sense NoSQL databases market share data (2025). Note: "Others" includes Redis, Cassandra, Neo4j, etc.</p>
  </div>
        </div>

        <table>
          <tbody>
            <tr>
              <th>Competitor</th>
              <th>Type</th>
              <th>Key Strength</th>
              <th>Key Weakness vs. MongoDB</th>
            </tr>
            <tr>
              <td><strong>Amazon DynamoDB</strong></td>
              <td>Key-value / Document (AWS)</td>
              <td>Deep AWS integration, serverless, infinite scale</td>
              <td>Limited query flexibility, AWS lock-in</td>
            </tr>
            <tr>
              <td><strong>Azure Cosmos DB</strong></td>
              <td>Multi-model (Azure)</td>
              <td>Global distribution, multi-API, Microsoft ecosystem</td>
              <td>Complex pricing, Azure-centric</td>
            </tr>
            <tr>
              <td><strong>PostgreSQL (+ extensions)</strong></td>
              <td>Relational + JSONB</td>
              <td>Free, mature, massive ecosystem, pgvector for AI</td>
              <td>Not native document store; schema management overhead</td>
            </tr>
            <tr>
              <td><strong>Couchbase</strong></td>
              <td>Document / Key-value</td>
              <td>SQL++ query language, embedded mobile DB</td>
              <td>Smaller community, less AI/vector tooling</td>
            </tr>
            <tr>
              <td><strong>Redis</strong></td>
              <td>In-memory / Multi-model</td>
              <td>Sub-millisecond latency, vector search in Redis 8.0</td>
              <td>Not designed for primary persistent document storage</td>
            </tr>
          </tbody>
        </table>
        <p class="small-note">Note: PostgreSQL is emerging as a major indirect competitor. In 2025, Snowflake acquired Crunchy Data ($250M) and Databricks acquired Neon ($1B), signaling PostgreSQL's dominance in the AI/GenAI data layer.</p>

        <!-- 7. INDUSTRY TRENDS -->
        <h2 class="section-header" id="industry-trends">7. Industry Trends &amp; Recent News</h2>
        <div class="two-col">
          <div class="company-card">
            <h3>Market Trends (2025–2026)</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>NoSQL market:</strong> $15B (2025) → $55.5B (2030) at 29.8% CAGR.</li>
              <li><strong>Vector DB market:</strong> $2.55B (2025), growing 22%+ CAGR. Vectors becoming a data type, not a database type.</li>
              <li><strong>AI drives adoption:</strong> 74% of orgs plan to use integrated vector DBs for agentic AI workflows (IDC, 2025).</li>
              <li><strong>Consolidation wave:</strong> IBM acquiring DataStax; Snowflake/Databricks investing heavily in PostgreSQL.</li>
              <li><strong>Serverless growth:</strong> Cloud-native, pay-per-use models accelerating ($28B → $90B by 2034).</li>
            </ul>
          </div>
          <div class="company-card">
            <h3>MongoDB Recent News (Last 6 Months)</h3>
            <ul style="list-style: none; padding: 0; font-size: 14px; line-height: 1.6">
              <li><strong>Jan 2026:</strong> Voyage 4 AI models + Automated Embedding launched at MongoDB.local SF.</li>
              <li><strong>Dec 2025:</strong> Q3 FY2026 results beat guidance. Wrongful termination lawsuit filed.</li>
              <li><strong>Nov 2025:</strong> CEO transition — CJ Desai replaces Dev Ittycheria.</li>
              <li><strong>Sep 2025:</strong> Vector Search extended to Community Edition and Enterprise Server.</li>
              <li><strong>Aug 2025:</strong> GraphRAG and natural language querying announced at Ai4.</li>
              <li><strong>2025:</strong> Gartner Magic Quadrant Leader for Cloud DBMS (4th consecutive year).</li>
            </ul>
          </div>
        </div>

        <!-- 8. CUSTOMER CASE STUDIES -->
        <h2 class="section-header" id="case-studies">8. Notable Customer Case Studies</h2>
        <table>
          <tbody>
            <tr>
              <th>Customer</th>
              <th>Industry</th>
              <th>Use Case</th>
              <th>Outcome</th>
            </tr>
            <tr>
              <td>Wells Fargo</td>
              <td>Financial Services</td>
              <td>Credit card platform modernization (Cards 2.0)</td>
              <td>7M+ transactions, sub-second latency, 40% vendor traffic via ODS</td>
            </tr>
            <tr>
              <td>Deutsche Telekom</td>
              <td>Telecom</td>
              <td>B2C digital channels for 30M customers</td>
              <td>Daily interactions: 50K → 1.5M; 15x legacy capacity</td>
            </tr>
            <tr>
              <td>Novo Nordisk</td>
              <td>Pharma</td>
              <td>Clinical Study Report generation with GenAI</td>
              <td>Report time: 12 weeks → 10 minutes</td>
            </tr>
            <tr>
              <td>Financial Times</td>
              <td>Media</td>
              <td>AI-powered hybrid search (Atlas Vector Search)</td>
              <td>Built in 18 weeks; 1M+ daily searches</td>
            </tr>
            <tr>
              <td>Ubuy</td>
              <td>E-Commerce</td>
              <td>Product search across 300M+ products (180 countries)</td>
              <td>Search: 4–5 sec → milliseconds; 150M annual searches</td>
            </tr>
            <tr>
              <td>Sentra</td>
              <td>Cybersecurity</td>
              <td>Asset discovery platform</td>
              <td>Indexes 70% smaller; queries: 3 min → 1 sec; scaled to 1B assets</td>
            </tr>
          </tbody>
        </table>

        <!-- 9. RISK ASSESSMENT -->
        <h2 class="section-header" id="risk-assessment">9. Risk Assessment</h2>
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 32px">
          <div class="risk-card medium">
            <div class="risk-title">CEO Transition</div>
            <div>New CEO (CJ Desai) since Nov 2025. Strong track record at ServiceNow and Cloudflare, but execution risk during leadership change.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title">Securities Class Action</div>
            <div>Active shareholder lawsuit (filed Jul 2024) alleging misleading statements about sales restructuring. Pending in SDNY.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title">Vendor Lock-in</div>
            <div>Proprietary query language (MQL), Atlas-specific services, and SSPL license create meaningful switching costs.</div>
          </div>
          <div class="risk-card low">
            <div class="risk-title">Financial Stability</div>
            <div>$2.3B cash, FCF positive, 19% growth. No near-term solvency risk. Near GAAP breakeven.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title">Pricing Escalation</div>
            <div>Atlas costs can escalate unpredictably at scale due to egress, backup, and auto-scaling charges.</div>
          </div>
          <div class="risk-card low">
            <div class="risk-title">Competitive Pressure</div>
            <div>PostgreSQL + pgvector gaining traction for AI workloads. Hyperscaler DBs (DynamoDB, Cosmos) compete on integration.</div>
          </div>
          <div class="risk-card medium">
            <div class="risk-title">Wrongful Termination Suit</div>
            <div>Lawsuit filed Dec 2025 alleging disability discrimination. Reputational risk if it gains media attention.</div>
          </div>
          <div class="risk-card low">
            <div class="risk-title">Security / Compliance</div>
            <div>Extensive certifications (SOC 2, ISO, PCI, HIPAA, FedRAMP). Encryption on by default. Low security risk.</div>
          </div>
          <div class="risk-card low">
            <div class="risk-title">Product Viability</div>
            <div>Gartner Leader 4 years running. 200K+ new developers/month on Atlas. Strong product roadmap with AI focus.</div>
          </div>
        </div>

        <!-- 10. ESG -->
        <h2 class="section-header" id="esg">10. ESG &amp; Sustainability</h2>
        <div class="score-section">
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#f59e0b" stroke-width="8" stroke-dasharray="150.8 251.3" stroke-dashoffset="-62.8" stroke-linecap="round" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="50" text-anchor="middle" font-size="18" font-weight="700" fill="#374151" dominant-baseline="middle">60</text>
            </svg>
            <div class="score-label">EcoVadis Silver</div>
            <div class="score-source">ESG Rating</div>
          </div>
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#3b82f6" stroke-width="8" stroke-dasharray="175.9 251.3" stroke-dashoffset="-62.8" stroke-linecap="round" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="50" text-anchor="middle" font-size="22" font-weight="700" fill="#374151" dominant-baseline="middle">B</text>
            </svg>
            <div class="score-label">CDP Climate</div>
            <div class="score-source">Climate Score</div>
          </div>
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#f59e0b" stroke-width="8" stroke-dasharray="125.7 251.3" stroke-dashoffset="-62.8" stroke-linecap="round" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="46" text-anchor="middle" font-size="12" font-weight="700" fill="#374151">AVG</text>
              <text x="50" y="60" text-anchor="middle" font-size="8" fill="#6b7280">Mgmt of ESG</text>
            </svg>
            <div class="score-label">Sustainalytics</div>
            <div class="score-source">Risk Rating</div>
          </div>
          <div class="score-ring">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e5e7eb" stroke-width="8"></circle>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#22c55e" stroke-width="8" stroke-dasharray="200 251.3" stroke-dashoffset="-62.8" stroke-linecap="round" transform="rotate(-90 50 50)"></circle>
              <text x="50" y="50" text-anchor="middle" font-size="12" font-weight="700" fill="#374151" dominant-baseline="middle">2050</text>
            </svg>
            <div class="score-label">Net-Zero Target</div>
            <div class="score-source">Long-term Goal</div>
          </div>
        </div>
        <p class="small-note">MongoDB publishes annual ESG reports (latest: FY24). Emissions audited per ISO 14064. Primary carbon footprint from cloud partner data centers (AWS, Azure, GCP). SASB-aligned disclosures. No FY25 report published as of Feb 2026.</p>

        <!-- RECOMMENDATION -->
        <div class="recommendation">
          <h2>Recommendation</h2>
          <p>
            MongoDB is a strong candidate for organizations building modern, document-oriented applications — particularly
            those investing in AI/GenAI capabilities. The company's financial health is solid, its product roadmap is
            aggressive and well-aligned with industry trends, and its security certifications are comprehensive. The
            primary concerns are pricing complexity at scale, vendor lock-in through proprietary tooling, and ongoing
            litigation (securities class action and wrongful termination). The CEO transition adds short-term uncertainty
            but CJ Desai's track record is impressive.
          </p>
          <p class="verdict" style="margin-top: 12px; font-weight: 600">
            Verdict: STRONG YES — Strong product and market position, but negotiate pricing protections
            (caps, committed-use discounts) and build exit optionality into your contract. Request references from
            customers at similar scale. Monitor litigation developments.
          </p>
        </div>

        <!-- DATA CONFIDENCE -->
        <h2 class="section-header" style="margin-top: 28px">Data Confidence &amp; Validation Notes</h2>
        <table>
          <tbody>
            <tr>
              <th>Data Point</th>
              <th>Sources Used</th>
              <th>Confidence</th>
            </tr>
            <tr>
              <td>Revenue &amp; financials</td>
              <td>MongoDB IR (SEC filings), PR Newswire, StockTitan</td>
              <td><span class="confidence high">HIGH</span> — Direct from filings</td>
            </tr>
            <tr>
              <td>Customer count &amp; Atlas %</td>
              <td>MongoDB earnings releases (Q1–Q3 FY2026)</td>
              <td><span class="confidence high">HIGH</span> — Company-reported</td>
            </tr>
            <tr>
              <td>Market share (~45%)</td>
              <td>6sense market data</td>
              <td><span class="confidence medium">MEDIUM</span> — Third-party estimate; methodology not published</td>
            </tr>
            <tr>
              <td>Employee count</td>
              <td>PitchBook (5,558), Tracxn (7,594), LeadIQ (7,600)</td>
              <td><span class="confidence medium">MEDIUM</span> — Sources diverge; true count likely 5,500–7,600</td>
            </tr>
            <tr>
              <td>Security certifications</td>
              <td>MongoDB Trust Center, official compliance pages</td>
              <td><span class="confidence high">HIGH</span> — Direct from vendor; verifiable</td>
            </tr>
            <tr>
              <td>Litigation</td>
              <td>Court filings (SDNY), law firm press releases, CNBC, Archyde</td>
              <td><span class="confidence high">HIGH</span> — Public legal records</td>
            </tr>
            <tr>
              <td>ESG ratings</td>
              <td>MongoDB ESG report, CSRHub, Sustainalytics</td>
              <td><span class="confidence high">HIGH</span> — Published ratings</td>
            </tr>
            <tr>
              <td>NoSQL market size ($55B by 2030)</td>
              <td>Mordor Intelligence, Business Research Insights</td>
              <td><span class="confidence medium">MEDIUM</span> — Analyst projections; estimates vary</td>
            </tr>
            <tr>
              <td>Case study outcomes</td>
              <td>MongoDB.com case studies, AWS case study</td>
              <td><span class="confidence medium">MEDIUM</span> — Vendor-published; may be selectively positive</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

    <div class="footer">Buyer Brief — MongoDB, Inc. | Prepared for Kevin, Infinity Loop AI | Methodology: Triangulated research (2+ independent sources per claim) | Feb 26, 2026</div>

  </div>
</div>`;

const MONGODB_INTAKE: BuyerBriefIntake = {
    supplierName: "MongoDB, Inc.",
    supplierWebsite: "https://www.mongodb.com",
    supplierType: SupplierTypeGroup.SOFTWARE_SAAS,
    evaluationGoal: EvaluationGoal.NEW_SUPPLIER_EVALUATION,
    selectedTopics: [
        "company_overview",
        "financial_health",
        "market_position",
        "product_capabilities",
        "security_compliance",
        "pricing_model",
    ],
    selectedAddons: [],
};

export const DEMO_BRIEFS: BuyerBrief[] = [
    {
        id: 6,
        organizationId: 1,
        creatorId: 1,
        status: BriefStatus.COMPLETED,
        supplierName: "MongoDB, Inc.",
        supplierWebsite: "https://www.mongodb.com",
        supplierType: SupplierTypeGroup.SOFTWARE_SAAS,
        evaluationGoal: EvaluationGoal.NEW_SUPPLIER_EVALUATION,
        selectedTopics: MONGODB_INTAKE.selectedTopics,
        selectedAddons: MONGODB_INTAKE.selectedAddons,
        intakePayload: MONGODB_INTAKE,
        briefHtml: MONGODB_BRIEF_HTML,
        verdict: Verdict.STRONG_YES,
        modelUsed: "claude-sonnet-4-5-20250514",
        webSearchesExecuted: 28,
        recordCreationDate: "2026-03-07T14:30:00Z",
        recordCompletionDate: "2026-03-07T16:15:00Z",
    },
    {
        id: 5,
        organizationId: 1,
        creatorId: 1,
        status: BriefStatus.COMPLETED,
        supplierName: "Amazon Web Services (AWS)",
        supplierWebsite: "https://aws.amazon.com",
        supplierType: SupplierTypeGroup.CLOUD_INFRASTRUCTURE,
        evaluationGoal: EvaluationGoal.COMPETITIVE_COMPARISON,
        selectedTopics: AWS_INTAKE.selectedTopics,
        selectedAddons: AWS_INTAKE.selectedAddons,
        intakePayload: AWS_INTAKE,
        briefHtml: AWS_BRIEF_HTML,
        verdict: Verdict.CONDITIONAL,
        modelUsed: "claude-sonnet-4-5-20250514",
        webSearchesExecuted: 32,
        recordCreationDate: "2026-03-05T11:00:00Z",
        recordCompletionDate: "2026-03-05T13:45:00Z",
    },
    {
        id: 8,
        organizationId: 1,
        creatorId: 1,
        status: BriefStatus.COMPLETED,
        supplierName: "Snowflake Inc.",
        supplierWebsite: "https://www.snowflake.com/",
        supplierType: SupplierTypeGroup.SOFTWARE_SAAS,
        evaluationGoal: EvaluationGoal.RENEWAL_DECISION,
        selectedTopics: SNOWFLAKE_INTAKE.selectedTopics,
        selectedAddons: SNOWFLAKE_INTAKE.selectedAddons,
        intakePayload: SNOWFLAKE_INTAKE,
        briefHtml: SNOWFLAKE_BRIEF_HTML,
        verdict: Verdict.RENEGOTIATE,
        modelUsed: "claude-sonnet-4-5-20250514",
        webSearchesExecuted: 47,
        recordCreationDate: "2026-02-21T10:15:00Z",
        recordCompletionDate: "2026-02-21T14:32:00Z",
    },
    {
        id: 2,
        organizationId: 1,
        creatorId: 1,
        status: BriefStatus.COMPLETED,
        supplierName: "Salesforce",
        supplierWebsite: "https://www.salesforce.com",
        supplierType: SupplierTypeGroup.SOFTWARE_SAAS,
        evaluationGoal: EvaluationGoal.NEW_SUPPLIER_EVALUATION,
        selectedTopics: [
            "company_overview",
            "financial_health",
            "market_position",
            "product_capabilities",
            "security_compliance",
            "pricing_model",
        ],
        selectedAddons: [],
        intakePayload: {
            supplierName: "Salesforce",
            supplierWebsite: "https://www.salesforce.com",
            supplierType: SupplierTypeGroup.SOFTWARE_SAAS,
            evaluationGoal: EvaluationGoal.NEW_SUPPLIER_EVALUATION,
            selectedTopics: [
                "company_overview",
                "financial_health",
                "market_position",
                "product_capabilities",
                "security_compliance",
                "pricing_model",
            ],
            selectedAddons: [],
        },
        briefHtml: SALESFORCE_BRIEF_HTML,
        verdict: Verdict.YES,
        webSearchesExecuted: 0,
        recordCreationDate: "2026-03-03T09:00:00Z",
    },
];

export const DEMO_JOBS: BuyerBriefJob[] = [
    {
        id: 102,
        organizationId: 1,
        briefId: 3,
        jobType: "buyer_brief_v2",
        supplierName: "Accenture",
        status: BriefJobStatus.VERIFYING,
        currentStep: "verifying",
        startTime: "2026-03-03T09:15:30Z",
        retryCount: 0,
    },
    {
        id: 103,
        organizationId: 1,
        briefId: 4,
        jobType: "buyer_brief_v2",
        supplierName: "FedEx Logistics",
        status: BriefJobStatus.QUEUED,
        currentStep: "queued",
        startTime: "2026-03-03T09:30:30Z",
        retryCount: 0,
    },
];
